<template>
  <div class="person-center-tab-wrap m-main" ref="editorDOM">
    <div class="left-box">
      <div class="top-box">
        <img src="../images/presentation-img.png" alt="" />
        <span>个人中心</span>
      </div>
      <ul>
        <li @click="changeTab(1)" :class="{ active: activeTab == 1 }">
          <img src="../images/presentation-img1.png" alt="" />
          <span class="one-span">会员权益</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(2)" :class="{ active: activeTab == 2 }">
          <img src="../images/presentation-img2.png" alt="" />
          <span class="one-span">我的优惠券</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(3)" :class="{ active: activeTab == 3 }">
          <img src="../images/presentation-img3.png" alt="" />
          <span class="one-span">就诊人管理</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(4)" :class="{ active: activeTab == 4 }">
          <img src="../images/presentation-img4.png" alt="" />
          <span class="one-span">门诊预约记录</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(5)" :class="{ active: activeTab == 5 }">
          <img src="../images/presentation-img5.png" alt="" />
          <span class="one-span">体检预约记录</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(6)" :class="{ active: activeTab == 6 }">
          <img src="../images/presentation-img6.png" alt="" />
          <span class="one-span">报告查询</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(7)" :class="{ active: activeTab == 7 }">
          <img src="../images/presentation-img7.png" alt="" />
          <span class="one-span">消费明细</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <!-- <li @click="changeTab(8)" :class="{ active: activeTab == 8 }">
          <img src="../images/presentation-img7.png" alt="" />
          <span class="one-span">电子发票</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li> -->
      </ul>
    </div>
    <div class="right-box">
      <!-- 会员权益 begin -->
      <div class="vip-management" v-if="activeBox == 1">
        <div v-if="!SCREEN.mobile">
          <div class="outpatient-people">
            <h2>权益列表</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="outpatientPeopleChangeforVIP"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span"
              >已有订单（{{ vipOrderData.length }}条）</span
            >
          </div>
          <div class="table">
            <a-table
              class="a-table"
              :columns="vipOrderColumns"
              :data-source="vipOrderData"
              :pagination="false"
            >
            </a-table>
          </div>
        </div>
        <div v-if="SCREEN.mobile">
          <div class="outpatient-mobile-people">
            <h2>权益列表</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="outpatientPeopleChangeforVIP"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span"
              >已有订单（{{ vipOrderData.length }}条）</span
            >
          </div>
          <div class="line"></div>
          <div class="table mobile-table">
            <ul v-for="(item, index) in vipOrderData" :key="item.id + index">
              <li>
                <span class="one-span">订单编号:</span
                ><span class="two-span">{{ item.name }}</span>
              </li>
              <li>
                <span class="one-span">客户:</span
                ><span class="two-span">{{ item.cardNo }}</span>
              </li>
              <li>
                <span class="one-span">有效开始日期:</span
                ><span class="two-span">{{ item.idNo }}</span>
              </li>
              <li>
                <span class="one-span">有效结束日期:</span
                ><span class="two-span">{{ item.phone }}</span>
              </li>
              <li>
                <span class="one-span">开单科室:</span>
                <span class="two-span">
                  {{ item.phone }}
                </span>
              </li>
              <li>
                <span class="one-span">优惠总金额:</span>
                <span class="two-span">
                  {{ item.phone }}
                </span>
              </li>
              <li>
                <span class="one-span">总金额:</span>
                <span class="two-span">
                  {{ item.phone }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 会员权益 end -->

      <!-- 我的优惠券 begin -->
      <div class="consultant-management" v-if="activeBox == 2">
        <div v-if="!SCREEN.mobile">
          <div class="outpatient-people">
            <h2>卡券列表</h2>
            <div class="add-consultant-people">
              <span class="one-span" @click="cardVisiblePc = true"
                >卡券激活绑定</span
              >
              <span class="two-span"
                >就诊人:
                <a-select
                  v-model="activeHisPatientId"
                  class="select"
                  @change="outpatientPeopleChangeforConpon"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in consultantPeopleList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select></span
              >
            </div>
          </div>
          <div class="table">
            <a-table
              :defaultExpandAllRows="true"
              class="a-table"
              :columns="cardColumns"
              :data-source="cardData"
              :pagination="false"
             
            >
              <template slot="couponType" slot-scope="text, record">
                <span class="two-span">
                  <span v-if="record.couponType == 5">金额券</span>
                  <span v-if="record.couponType == 10">折扣券</span>
                </span>
              </template>
              <template slot="couponStatus" slot-scope="text, record">
                <span class="two-span">
                  <span v-if="record.couponStatus == 2">已失效</span>
                  <span v-if="record.couponStatus == 100000000">已激活</span>
                  <span v-if="record.couponStatus == 100000001">已使用</span>
                </span>
              </template>
                <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
                  <p>激活时间：{{record.activateTime}} <span style="margin-left:10px">核销时间：{{record.cancelledTime}}</span></p>
                  <p>说明：{{ record.cancelledReason }}</p>
                </div>
            </a-table>
          </div>
        </div>
        <div v-if="SCREEN.mobile">
          <div class="outpatient-mobile-people">
            <h2>卡券列表</h2>
            <div class="add-consultant-people">
              <span class="one-span" @click="cardVisiblePc = true"
                >卡券激活绑定</span
              >
            </div>
            <p
              style="display: flex;
                   align-items: center;
                   margin-top: 10px;"
            >
              <span style="width:60px;font-size:14px">就诊人:</span>
              <a-select
                v-model="activeHisPatientId"
                class="select"
                @change="outpatientPeopleChangeforConpon"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </p>
          </div>
          <div class="line"></div>
          <div class="table mobile-table">
            <ul v-for="(item, index) in cardData" :key="item.id + index">
              <li>
                <span class="one-span">券号:</span
                ><span class="two-span">{{ item.couponNumber }}</span>
              </li>
              <li>
                <span class="one-span">类型:</span
                ><span class="two-span">
                  <span v-if="item.couponType == 10">折扣券</span>
                  <span v-if="item.couponType == 5">金额券</span>
                  </span>
              </li>
              <li>
                <span class="one-span">面额:</span
                ><span class="two-span">{{ item.couponValue }}</span>
              </li>
              <li>
                <span class="one-span">折扣:</span>
                <span class="two-span">{{ item.couponDiscount }}</span>
              </li>
              <li>
                <span class="one-span">有效开始日期:</span
                ><span class="two-span">{{ item.startDate }}</span>
              </li>
              <li>
                <span class="one-span">有效结束日期:</span>
                <span class="two-span">{{ item.endDate }}</span>
              </li>
              <li>
                <span class="one-span">状态:</span>
                <span class="two-span">
                  <span v-if="item.couponStatus == 2">已失效</span>
                  <span v-if="item.couponStatus == 100000000">已激活</span>
                  <span v-if="item.couponStatus == 100000001">已使用</span>
                </span>
              </li>
              <li>
                <span class="one-span">激活时间:</span>
                <span class="two-span">{{ item.activateTime }}</span>
              </li>
              <li>
                <span class="one-span">核销时间:</span>
                <span class="two-span">{{ item.cancelledTime }}</span>
              </li>
              <li>
                <span class="one-span">说明:</span>
                <span class="two-span">{{ item.cancelledReason }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 我的优惠券 end -->
      <!-- 卡券激活绑定PC端  begin -->
      <a-modal
        title=""
        v-model="cardVisiblePc"
        @cancel="closeCardBind"
        width="820px"
        :footer="null"
      >
        <div class="add-consultant-people-dialog">
          <a-form
            :model="cardForm"
            labelAlign="left"
            :style="`width:${!SCREEN.mobile ? '70%' : '100%'};margin:0 auto`"
          >
            <a-form-item
              label="就诊人"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 21 }"
            >
              <a-select v-model="cardForm.hisPatientId" class="select">
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <h2 style="font-weight:600;margin-bottom:10px">请输入券号</h2>
            <a-form-item label="">
              <a-input-search
                v-model="cardForm.counpNo"
                placeholder="请输入您的卡券号"
                enter-button="确认"
                size="large"
                @search="cardAdd"
              />
            </a-form-item>
          </a-form>
        </div>
      </a-modal>
      <!-- 卡券激活绑定PC端 end -->

      <!-- 就诊人管理 begin -->
      <div class="consultant-management" v-if="activeBox == 3">
        <div v-if="!SCREEN.mobile">
          <h2>就诊人管理</h2>
          <div class="add-consultant-people">
            <span class="one-span" @click="addPcConsultantPeople"
              >添加新的就诊人</span
            >
            <span class="two-span"
              >已有就诊人（{{ consultantData.length }}/9）</span
            >
          </div>
          <div class="table">
            <a-table
              class="a-table"
              :columns="consultantColumns"
              :data-source="consultantData"
              :pagination="false"
            >
              <template slot="relationshipCode" slot-scope="text, record">
                <span v-if="record.relation == 0">本人</span>
                <span v-if="record.relation == 1">子女</span>
                <span v-if="record.relation == 2">父母</span>
                <span v-if="record.relation == 3">夫妻</span>
                <span v-if="record.relation == 4">其它</span>
              </template>
              <template slot="action" slot-scope="text, record">
                <a
                  class="btn btn-blue"
                  @click="makeAnAppointmentRocord(record.hisId)"
                  >预约记录</a
                >
                <a
                  class="btn btn-blue"
                  @click="
                    cancelBind(
                      record.id,
                      record.relationshipCode,
                      record.relation
                    )
                  "
                  >解绑</a
                >
              </template>
            </a-table>
          </div>
        </div>
        <div v-if="SCREEN.mobile">
          <h2>就诊人管理</h2>
          <div class="add-consultant-people">
            <span class="one-span" @click="addMobileConsultantPeople"
              >添加新的就诊人</span
            >
            <span class="two-span"
              >已有就诊人（{{ consultantData.length }}/9）</span
            >
          </div>
          <div class="line"></div>
          <div class="table mobile-table">
            <ul v-for="(item, index) in consultantData" :key="item.id + index">
              <li>
                <span class="one-span">姓名:</span
                ><span class="two-span">{{ item.name }}</span>
              </li>
              <li>
                <span class="one-span">诊疗卡号:</span
                ><span class="two-span">{{ item.cardNo }}</span>
              </li>
              <li>
                <span class="one-span">证件号:</span
                ><span class="two-span">{{ item.idNo }}</span>
              </li>
              <li>
                <span class="one-span">手机号:</span
                ><span class="two-span">{{ item.phoneHide || '' }}</span>
              </li>
              <li>
                <span class="one-span">关系:</span>
                <span class="two-span">
                  <span v-if="item.relation == 0">本人</span>
                  <span v-if="item.relation == 1">子女</span>
                  <span v-if="item.relation == 2">父母</span>
                  <span v-if="item.relation == 3">夫妻</span>
                  <span v-if="item.relation == 4">其它</span>
                </span>
              </li>
              <li>
                <span class="one-span">操作:</span>
                <span class="two-span">
                  <a
                    class="btn btn-blue"
                    @click="makeAnAppointmentRocord(item.hisId)"
                    >预约记录</a
                  >
                  <a
                    class="btn btn-blue"
                    @click="
                      cancelBind(item.id, item.relationshipCode, item.relation)
                    "
                    >解绑</a
                  >
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 就诊人管理 end -->

      <!-- 添加新的就诊人PC端 begin -->
      <a-modal
        title="添加新的就诊人"
        v-model="visiblePc"
        centered
        @cancel="closePcConsultantPeople"
        width="820px"
      >
        <template slot="footer">
          <a-button
            key="submit"
            type="primary"
            :loading="confirmLoading"
            @click="handleConsultantOk"
          >
            确认添加
          </a-button>
        </template>
        <div class="add-consultant-people-dialog">
          <ul>
            <li>
              <span class="one-span">姓名：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.name" class="width-220-px"
              /></span>
            </li>
            <li>
              <span class="one-span">证件类型：</span>
              <span class="two-span">
                <a-select
                  class="select width-220-px"
                  v-model="consultantForm.idType"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in zjTypeList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">证件号码：</span>
              <span class="two-span"
                ><a-input
                  @keyup="enterIdNo"
                  v-model="consultantForm.idNo"
                  :maxLength="30"
                  class="width-220-px"
              /></span>
            </li>
            <li>
              <span class="one-span">性别：</span>
              <span class="two-span">
                <a-select
                  class="select width-220-px"
                  v-model="consultantForm.gender"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in genderList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">出生日期：</span>
              <span class="two-span">
                <a-date-picker
                  v-model="consultantForm.birthday"
                  valueFormat="YYYY-MM-DD"
                  class="width-220-px"
                  placeholder="请选择"
                  :disabled-date="pickerOptions"
                  :disabled="consultantForm.idType == '01'"
                />
              </span>
            </li>
            <!-- <li>
              <span class="one-span">民族：</span>
              <span class="two-span">
                <a-select class="select width-220-px" v-model="consultantForm.nation">
                  <a-select-option :value="item.code" v-for="(item, index) in nationList" :key="item.code + index">
                    {{item.name}}
                  </a-select-option>
                </a-select>
              </span>
            </li> -->
            <li>
              <span class="one-span">手机号码：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.phone" class="width-220-px"
              /></span>
            </li>
            <li>
              <span class="one-span">验证码：</span>
              <span class="two-span"
                ><a-input
                  v-model="consultantForm.verifyCode"
                  class="width-220-px"
                /><span @click="getYzm" class="send-yzm">{{
                  yzmTxt
                }}</span></span
              >
            </li>
            <li>
              <span class="one-span">与本人关系:</span>
              <span class="two-span">
                <a-select
                  class="select width-220-px"
                  v-model="consultantForm.relation"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in relationshipList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
          </ul>
          <AddPersonAgreement v-model="consultantForm.agreeCheck" :section="true" :sectiontips="true" :showpersonal="false" hospital="hf" />
          <AddPersonAgreement v-model="consultantForm.agree360Check" :showtips="false" :michref="mic.micUrl" hospital="hf" />
        </div>
      </a-modal>
      <!-- 添加新的就诊人PC端 end -->

      <!-- 添加新的就诊人手机端 begin -->
      <a-modal
        title="添加新的就诊人"
        centered
        v-model="visibleMobile"
        @cancel="closeMobileConsultantPeople"
        width="10rem"
      >
        <template slot="footer">
          <a-button
            key="submit"
            type="primary"
            :loading="confirmLoading"
            @click="handleConsultantOk"
          >
            确认添加
          </a-button>
        </template>
        <div class="add-consultant-people-mobile-dialog">
          <ul>
            <li>
              <span class="one-span">姓名：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.name" class=""
              /></span>
            </li>
            <li>
              <span class="one-span">证件类型：</span>
              <span class="two-span">
                <a-select class="select" v-model="consultantForm.idType">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in zjTypeList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">证件号码：</span>
              <span class="two-span"
                ><a-input
                  @keyup="enterIdNo"
                  v-model="consultantForm.idNo"
                  :maxLength="30"
                  class=""
              /></span>
            </li>
            <li>
              <span class="one-span">性别：</span>
              <span class="two-span">
                <a-select class="select" v-model="consultantForm.gender">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in genderList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">出生日期：</span>
              <span class="two-span">
                <a-date-picker
                  v-model="consultantForm.birthday"
                  valueFormat="YYYY-MM-DD"
                  class="select"
                  placeholder="请选择"
                  :disabled-date="pickerOptions"
                />
              </span>
            </li>
            <li>
              <span class="one-span">手机号码：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.phone" class=""
              /></span>
            </li>
            <li>
              <span class="one-span">验证码：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.verifyCode" class="" /><span
                  @click="getYzm"
                  class="send-yzm"
                  >{{ yzmTxt }}</span
                ></span
              >
            </li>
            <li>
              <span class="one-span">与本人关系:</span>
              <span class="two-span">
                <a-select class="select" v-model="consultantForm.relation">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in relationshipList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
          </ul>
          <AddPersonAgreement v-model="consultantForm.agreeCheck" :section="true" :sectiontips="true" :showpersonal="false" hospital="hf" />
          <AddPersonAgreement v-model="consultantForm.agree360Check" :showtips="false" :michref="mic.micUrl" hospital="hf" />
        </div>
      </a-modal>
      <!-- 添加新的就诊人手机端 end -->

      <!-- 解除绑定弹窗 -->
      <a-modal title="" v-model="cbVisible" width="200px">
        <template slot="footer">
          <a-button key="submit" type="primary" @click="handleCbOk">
            是
          </a-button>
          <a-button key="back" type="primary" @click="handleCbCancel">
            否
          </a-button>
        </template>
        <p>是否确定解除绑定</p>
      </a-modal>

      <!-- 门诊预约 begin -->
      <div class="outpatient-appointment" v-if="activeBox == 4">
        <div v-if="!SCREEN.mobile">
          <div class="outpatient-people">
            <h2>门诊预约</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="outpatientPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span"
              >预约信息（{{ outpatientData.length }}条）</span
            >
          </div>
          <div class="table">
            <a-table
              class="a-table"
              :columns="outpatientColumns"
              :data-source="outpatientData"
              :pagination="false"
            >
              <template slot="payStatus" slot-scope="text, record">
                <a
                  class="btn btn-blue admb-5-px"
                  v-if="record.payStatus == 'TB'"
                  >预约成功</a
                >
                <a
                  @click="cancelSubscribe(record)"
                  class="btn admb-5-px"
                  v-if="record.payStatus == 'TB'"
                  >取消预约</a
                >
                <!-- <a
                  @click="goToPay(record)"
                  class="btn"
                  v-if="record.payStatus == 'TB'"
                  >去支付</a
                > -->
                <a class="btn btn-default" v-if="record.payStatus == 'P'"
                  >支付成功</a
                >
                <!-- <a
                  @click="returnNum(record)"
                  class="btn"
                  v-if="record.payStatus == 'P'"
                  >退号</a
                > -->
                <a class="btn btn-default" v-if="record.payStatus == 'C'"
                  >已取消</a
                >
                <a class="btn btn-default" v-if="record.payStatus == 'R'"
                  >已退号</a
                >
                <a class="btn btn-default" v-if="record.payStatus == 'J'"
                  >已过期</a
                >
              </template>
            </a-table>
          </div>
        </div>
        <div v-if="SCREEN.mobile">
          <div class="outpatient-mobile-people">
            <h2>门诊预约</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="outpatientPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span"
              >预约信息（{{ outpatientData.length }}条）</span
            >
          </div>
          <div class="table mobile-table">
            <ul v-for="(item, index) in outpatientData" :key="item.id + index">
              <li>
                <span class="one-span">就诊科室:</span
                ><span class="two-span">{{ item.hisDeptName }}</span>
              </li>
              <li>
                <span class="one-span">医师:</span
                ><span class="two-span">{{ item.hisDoctorName }}</span>
              </li>
              <li>
                <span class="one-span">订单号:</span
                ><span class="two-span">{{ item.orderNo }}</span>
              </li>
              <li>
                <span class="one-span">预约时间:</span
                ><span class="two-span">{{ item.visitTime }}</span>
              </li>
              <li>
                <span class="one-span">状态:</span>
                <span class="two-span">
                  <a class="btn btn-blue" v-if="item.payStatus == 'TB'"
                    >预约成功</a
                  >
                  <a
                    @click="cancelSubscribe(item)"
                    class="btn"
                    v-if="item.payStatus == 'TB'"
                    >取消预约</a
                  >
                  <!-- <a
                    @click="selectPaymentPhone(item)"
                    class="btn"
                    v-if="item.payStatus == TB"
                    >去支付</a
                  > -->
                  <a class="btn btn-default" v-if="item.payStatus == 'P'"
                    >支付成功</a
                  >
                  <!-- <a
                    @click="returnNum(item)"
                    class="btn"
                    v-if="item.payStatus == 'P'"
                    >退号</a
                  > -->
                  <a class="btn btn-default" v-if="item.payStatus == 'C'"
                    >已取消</a
                  >
                  <a class="btn btn-default" v-if="item.payStatus == 'R'"
                    >已退号</a
                  >
                  <a class="btn btn-default" v-if="item.payStatus == 'J'"
                    >已过期</a
                  >
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 门诊预约 end -->

      <!-- 体检预约 begin -->
      <div class="medical-appointment" v-if="activeBox == 5">
        <div v-if="!SCREEN.mobile">
          <div class="outpatient-people">
            <h2>体检预约</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="medicalAppointmentPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span">预约信息（{{ medicalData.length }}条）</span>
          </div>
          <div class="table">
            <a-table
              class="a-table"
              :columns="medicalColumns"
              :data-source="medicalData"
              :pagination="false"
            >
              <template slot="reserveDate" slot-scope="text, record">
                <div>{{ record.reserveDate }} {{ record.reserveTime }}</div>
              </template>
              <template slot="reserveStatus" slot-scope="text, record">
                <a
                  @click="cancelMakeAnAppointment(record)"
                  class="btn"
                  v-if="
                    (record.reserveStatus == 0 || record.reserveStatus == 1) &&
                      record.reserveType != 'G'
                  "
                  >取消预约</a
                >
                <!-- <a
                  @click="getExamBookDetail(record)"
                  class="btn"
                  v-if="record.reserveStatus == 0"
                  >立即支付</a
                > -->
                <!-- <a
                  @click="goExamRefund(record)"
                  class="btn"
                  v-if="record.reserveStatus == 4 && record.reserveType != 'G'"
                  >退费</a
                > -->
                <!-- <a @click="makeAnAppointmentRocord(record.payStatus)" class="btn" v-if=" record.payStatus == 2 && record.reserveStatus == 1">预约记录</a> -->
                <!-- <a class="btn btn-blue" v-if=" record.payStatus == 2 && record.reserveStatus == 2">登记</a>
                <a class="btn btn-blue" v-if=" record.payStatus == 2 && record.reserveStatus == 3">检查</a> -->
                <a
                  @click="refreshMakeAnAppointment(record.payStatus)"
                  class="btn"
                  v-if="record.reserveStatus == 2 || record.reserveStatus == 6"
                  >重新预约</a
                >
                <!-- <a @click="refreshMakeAnAppointment(record.payStatus)" class="btn" v-if="record.payStatus == 3 || record.payStatus == 4">重新预约</a> -->
              </template>
            </a-table>
          </div>
        </div>
        <div v-if="SCREEN.mobile">
          <div class="outpatient-mobile-people">
            <h2>体检预约</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="medicalAppointmentPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span">预约信息（{{ medicalData.length }}条）</span>
          </div>
          <div class="table mobile-table">
            <ul v-for="(item, index) in medicalData" :key="item.id + index">
              <li>
                <span class="one-span">体检科室:</span
                ><span class="two-span">{{ item.hisDeptDesc }}</span>
              </li>
              <li>
                <span class="one-span">体检套餐:</span>
                <span class="two-span">
                  {{ item.packageName }}
                </span>
              </li>
              <li>
                <span class="one-span">体检等级:</span
                ><span class="two-span">{{ item.levelDesc }}</span>
              </li>
              <li>
                <span class="one-span" style="width: 34%">预约体检时间:</span
                ><span class="two-span" style="width: 65%">
                  {{ item.reserveDate }} {{ item.reserveTime }}</span
                >
              </li>
              <li>
                <span class="one-span">状态:</span>
                <span class="two-span">
                  <a
                    @click="cancelMakeAnAppointment(item)"
                    class="btn"
                    v-if="
                      (item.reserveStatus == 0 || item.reserveStatus == 1) &&
                        record.reserveType != 'G'
                    "
                    >取消预约</a
                  >
                  <!-- <a
                    @click="getExamBookDetail(item)"
                    class="btn"
                    v-if="item.reserveStatus == 0"
                    >立即支付</a
                  > -->
                  <!-- <a
                    @click="goExamRefund(item)"
                    class="btn"
                    v-if="item.reserveStatus == 1 && record.reserveType != 'G'"
                    >医院处理中</a
                  > -->
                  <!-- <a @click="makeAnAppointmentRocord(item.payStatus)" class="btn" v-if=" item.payStatus == 2 && item.reserveStatus == 1">预约记录</a> -->
                  <!-- <a class="btn btn-blue" v-if=" item.payStatus == 2 && item.reserveStatus == 2">登记</a>
                  <a class="btn btn-blue" v-if=" item.payStatus == 2 && item.reserveStatus == 3">检查</a> -->
                  <a
                    @click="refreshMakeAnAppointment(item.payStatus)"
                    class="btn"
                    v-if="item.reserveStatus == 2 || item.reserveStatus == 6"
                    >重新预约</a
                  >
                  <!-- <a @click="refreshMakeAnAppointment(item.payStatus)" class="btn" v-if="item.payStatus == 3 || item.payStatus == 4">重新预约</a> -->
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 体检预约 end -->

      <!-- 报告查询 begin -->
      <div class="report-query" v-if="activeBox == 6">
        <div v-if="!SCREEN.mobile">
          <div v-if="showReport == 1">
            <div class="report-title-box">
              <span class="report-title">报告查询</span>
              <a-select
                v-model="activeHisPatientId"
                class="select"
                @change="reportConsultantPeopleChange"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="report-main-box">
              <div class="type-box">
                <span class="type-span">类型：</span>
                <a-select class="select" v-model="activeReportType">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in reportTypeList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </div>
              <!-- <div class="time-box">
                <span class="time-span">时间：</span>
                <a-date-picker class="time-picker" @change="onReportTimeOneChange" />
                <span class="to">至</span>
                <a-date-picker class="time-picker" @change="onReportTimeTwoChange" />
              </div> -->
              <div class="search-box">
                <span class="btn-box" @click="searchReportOne">
                  <img src="../images/presentation-img9.png" alt="" />
                  <span class="search-span">查询</span>
                </span>
              </div>
              <div class="report-tab">
                <div class="report-tab-head">
                  <p
                    :class="{ active: reportTypeTab == 1 }"
                    @click="reportTypeTab = 1"
                  >
                    <img src="../images/presentationpage1-img1.png" alt="" />
                    <span class="text">检验报告</span>
                    <span v-if="reportTypeTab == 1" class="triangle"></span>
                  </p>
                  <p
                    :class="{ active: reportTypeTab == 2 }"
                    @click="reportTypeTab = 2"
                  >
                    <img src="../images/presentationpage1-img2.png" alt="" />
                    <span class="text">检查报告</span>
                    <span v-if="reportTypeTab == 2" class="triangle"></span>
                  </p>
                  <p
                    :class="{ active: reportTypeTab == 3 }"
                    @click="reportTypeTab = 3"
                  >
                    <img src="../images/presentationpage1-img3.png" alt="" />
                    <span class="text">体检报告</span>
                    <span v-if="reportTypeTab == 3" class="triangle"></span>
                  </p>
                </div>
                <div class="report-tab-body">
                  {{ txt }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="showReport == 2">
            <div class="report-title-box">
              <span class="report-title">查询结果</span>
              <a-select
                v-model="activeHisPatientId"
                class="select"
                @change="reportConsultantPeopleChange"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="search-two-box">
              <span class="type-span">类型：</span>
              <a-select class="select" v-model="activeReportType">
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in reportTypeList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <!-- <span class="time-span">时间：</span>
              <a-date-picker class="time-picker" @change="onReportTimeOneChange" />
              <span class="to">至</span>
              <a-date-picker class="time-picker" @change="onReportTimeTwoChange" /> -->
              <span @click="searchReportTwo" class="search-btn">查询</span>
            </div>
            <div class="table" v-if="activeReportType != '03'">
              <a-table
                class="a-table"
                :columns="reportOneColumns"
                :data-source="reportOneData"
                :pagination="false"
              >
                <template slot="action" slot-scope="text, record">
                  <a @click="reviewReport(record.filePath)" class="btn">预览</a>
                  <a class="btn" v-if="false">下载</a>
                </template>
              </a-table>
            </div>
            <div class="table" v-if="activeReportType == '03'">
              <a-table
                class="a-table"
                :columns="reportTwoColumns"
                :data-source="reportTwoData"
                :pagination="false"
              >
                <template slot="action" slot-scope="text, record">
                  <a @click="reviewReport(record.filePath)" class="btn">预览</a>
                  <a class="btn" v-if="false">下载</a>
                </template>
              </a-table>
            </div>
          </div>
        </div>

        <div v-if="SCREEN.mobile">
          <div v-if="showReport == 1">
            <div class="report-title-box">
              <span class="report-title">报告查询</span>
              <a-select
                v-model="activeHisPatientId"
                class="select"
                @change="reportConsultantPeopleChange"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="report-main-box">
              <div class="type-box">
                <span class="type-span">类型：</span>
                <a-select class="select" v-model="activeReportType">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in reportTypeList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </div>
              <!-- <div class="time-box">
                <span class="time-span">时间：</span>
                <a-date-picker class="time-picker" @change="onReportTimeOneChange" />
                <span class="to">至</span>
                <a-date-picker class="time-picker" @change="onReportTimeTwoChange" />
              </div> -->
              <div class="search-box">
                <span class="btn-box" @click="searchReportOne">
                  <img src="../images/presentation-img9.png" alt="" />
                  <span class="search-span">查询</span>
                </span>
              </div>
              <div class="report-tab">
                <div class="report-tab-head">
                  <p
                    :class="{ active: reportTypeTab == 1 }"
                    @click="reportTypeTab = 1"
                  >
                    <img src="../images/presentationpage1-img1.png" alt="" />
                    <span class="text">检验报告</span>
                    <span v-if="reportTypeTab == 1" class="triangle"></span>
                  </p>
                  <p
                    :class="{ active: reportTypeTab == 2 }"
                    @click="reportTypeTab = 2"
                  >
                    <img src="../images/presentationpage1-img2.png" alt="" />
                    <span class="text">检查报告</span>
                    <span v-if="reportTypeTab == 2" class="triangle"></span>
                  </p>
                  <p
                    :class="{ active: reportTypeTab == 3 }"
                    @click="reportTypeTab = 3"
                  >
                    <img src="../images/presentationpage1-img3.png" alt="" />
                    <span class="text">体检报告</span>
                    <span v-if="reportTypeTab == 3" class="triangle"></span>
                  </p>
                </div>
                <div class="report-tab-body">
                  {{ txt }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="showReport == 2">
            <div class="report-two-title-box">
              <h2 class="report-title">查询结果</h2>
              <a-select
                v-model="activeHisPatientId"
                class="select"
                @change="reportConsultantPeopleChange"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="search-three-box">
              <span class="type-span">类型：</span>
              <a-select class="select" v-model="activeReportType">
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in reportTypeList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <!-- <div class="search-four-box">
              <span class="time-span">时间：</span>
              <a-date-picker class="time-picker" @change="onReportTimeOneChange" />
              <span class="to">至</span>
              <a-date-picker class="time-picker" @change="onReportTimeTwoChange" />
            </div> -->
            <div @click="searchReportTwo" class="search-btn-box">查询</div>
            <div class="line"></div>
            <div class="table mobile-table" v-if="activeReportType != '03'">
              <ul
                v-for="(item, index) in reportOneData"
                :key="item.reportDate + index"
              >
                <li>
                  <span class="one-span">名称:</span
                  ><span class="two-span">{{ item.fileName }}</span>
                </li>
                <li>
                  <span class="one-span">科室名称:</span
                  ><span class="two-span">{{ item.hisDeptName }}</span>
                </li>
                <li>
                  <span class="one-span">操作:</span
                  ><span class="two-span"
                    ><a @click="reviewReport(item.filePath)" class="btn"
                      >预览</a
                    ></span
                  >
                </li>
              </ul>
            </div>
            <div class="table mobile-table" v-if="activeReportType == '03'">
              <ul
                v-for="(item, index) in reportTwoData"
                :key="item.reportDate + index"
              >
                <li>
                  <span class="one-span">名称:</span
                  ><span class="two-span">{{ item.packageName }}</span>
                </li>
                <li>
                  <span class="one-span">姓名:</span
                  ><span class="two-span">{{ item.hisPatientName }}</span>
                </li>
                <li>
                  <span class="one-span">操作:</span
                  ><span class="two-span"
                    ><a @click="reviewReport(item.filePath)" class="btn"
                      >预览</a
                    ></span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 报告查询 end -->

      <!-- 消费明细 begin -->
      <div class="statement" v-if="activeBox == 7">
        <div v-if="!SCREEN.mobile">
          <div class="title-box">
            <span class="consumption-span">消费明细</span>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="statementConsultantPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="search-box">
            <span
              class="one-span"
              @click="getSevenChild(1)"
              :class="{ active: showChildTab == 1 }"
              >在院日清明细</span
            >
            <span
              class="two-span"
              @click="getSevenChild(2)"
              :class="{ active: showChildTab == 2 }"
              >已缴费记录</span
            >
            <span class="three-span">时间：</span>
            <a-date-picker
              class="time-picker"
              v-model="startDate"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择"
            />
            <!-- <span class="to">至</span>
            <a-date-picker class="time-picker" v-model="endDate" valueFormat="YYYY-MM-DD"  placeholder="请选择"/> -->
            <span class="five-span" @click="searchConsume">查询</span>
          </div>
          <div class="table-box">
            <div class="table-one-tab" v-if="showChildTab == 1">
              <a-table
                class="a-table"
                :columns="statementColumnsOne"
                :data-source="statementDataOne"
                :pagination="false"
              >
              </a-table>
            </div>
            <div class="table-two-tab" v-if="showChildTab == 2">
              <a-table
                class="a-table"
                :columns="statementColumnsTwo"
                :data-source="statementDataTwo"
                :pagination="pagination"
              >
              </a-table>
            </div>
          </div>
        </div>

        <div v-if="SCREEN.mobile">
          <div class="title-box">
            <h2 class="consumption-h2">消费明细</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="statementConsultantPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="search-box-one">
            <span
              class="one-span"
              @click="getSevenChild(1)"
              :class="{ active: showChildTab == 1 }"
              >在院日清明细</span
            >
            <span
              class="one-span"
              @click="getSevenChild(2)"
              :class="{ active: showChildTab == 2 }"
              >已缴费记录</span
            >
          </div>
          <div class="search-box-two">
            <span class="three-span">时间：</span>
            <a-date-picker
              class="time-picker"
              v-model="startDate"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择"
            />
            <!-- <span class="to">至</span>
            <a-date-picker class="time-picker" v-model="endDate" valueFormat="YYYY-MM-DD"  placeholder="请选择"/> -->
            <div class="search-div" @click="searchConsume">查询</div>
          </div>
          <div class="table mobile-table">
            <div class="table-one-tab" v-if="showChildTab == 1">
              <ul
                v-for="(item, index) in statementDataOne"
                :key="item.patientNo + index"
              >
                <!-- <li>
                  <span class="one-span">病人费别:</span
                  ><span class="two-span">{{ item.feeType }}</span>
                </li>
                <li>
                  <span class="one-span">科室:</span
                  ><span class="two-span">{{ item.dept }}</span>
                </li>
                <li>
                  <span class="one-span">病区:</span
                  ><span class="two-span">{{ item.ward }}</span>
                </li>
                <li>
                  <span class="one-span">总费用:</span
                  ><span class="two-span">{{ item.totalFee }}</span>
                </li>
                <li>
                  <span class="one-span">当日总计:</span
                  ><span class="two-span"> {{ item.todayFee }}</span>
                </li>
                <li>
                  <span class="one-span">余额:</span
                  ><span class="two-span"> {{ item.balance }}</span>
                </li> -->
                <li>
                  <span class="one-span">账单号:</span
                  ><span class="two-span">{{ item.billNo }}</span>
                </li>
                <li>
                  <span class="one-span">账户日期:</span
                  ><span class="two-span">{{ item.billDate }}</span>
                </li>
              </ul>
            </div>
            <div class="table-two-tab" v-if="showChildTab == 2">
              <ul
                v-for="(item, index) in statementDataTwo"
                :key="item.visitId + index"
              >
                <li>
                  <span class="one-span">票据流水号:</span
                  ><span class="two-span">{{ item.orderNo }}</span>
                </li>
                <!-- <li><span class="one-span">消费日期:</span><span class="two-span">{{item.name}}</span></li> -->
                <li>
                  <span class="one-span">票据总金额:</span
                  ><span class="two-span">{{ item.patientPay }}</span>
                </li>
                <li>
                  <span class="one-span">就诊日期:</span
                  ><span class="two-span">{{ item.visitDate }}</span>
                </li>
                <li>
                  <span class="one-span">就诊科室:</span
                  ><span class="two-span">{{ item.visitDept }}</span>
                </li>
                <li>
                  <span class="one-span">就诊医生:</span
                  ><span class="two-span">{{ item.visitDoctor }}</span>
                </li>
              </ul>
              <a-pagination
                @change="pageChange"
                :current="pagination.current"
                :pageSize="10"
                :total="pagination.total"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 消费明细 end -->

      <!-- 电子发票 begin -->
      <div class="statement" v-if="activeBox == 8">
        <div v-if="!SCREEN.mobile">
          <div class="title-box">
            <span class="consumption-span">电子发票</span>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="invoiceConsultantPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="search-box">
            <span
              class="one-span"
              @click="getEightChild(1)"
              :class="{ active: showChildTab == 1 }"
              >门诊发票</span
            >
            <span
              class="two-span"
              @click="getEightChild(2)"
              :class="{ active: showChildTab == 2 }"
              >体检发票</span
            >
            <!-- <span class="three-span">时间：</span>
            <a-date-picker class="time-picker" v-model="startDate" valueFormat="YYYY-MM-DD" placeholder="请选择"/>
            <span class="five-span" @click="searchConsume">查询</span> -->
          </div>
          <div class="table-box">
            <div class="table-one-tab" v-if="showChildTab == 1">
              <a-table
                class="a-table"
                :columns="invoiceColumnsOne"
                :data-source="invoiceDataOne"
                :pagination="pagination"
              >
                <template slot="action" slot-scope="text, record">
                  <a @click="reviewInvoice(record.pdfUrl)" class="btn">预览</a>
                  <!-- <a class="btn" @click="downloadInvoice(record.pdfUrl)">下载</a> -->
                </template>
              </a-table>
            </div>
            <div class="table-two-tab" v-if="showChildTab == 2">
              <a-table
                class="a-table"
                :columns="invoiceColumnsTwo"
                :data-source="invoiceDataTwo"
                :pagination="pagination"
              >
              </a-table>
            </div>
          </div>
        </div>

        <div v-if="SCREEN.mobile">
          <div class="title-box">
            <h2 class="consumption-h2">电子发票</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="invoiceConsultantPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="search-box-one">
            <span
              class="one-span"
              @click="getEightChild(1)"
              :class="{ active: showChildTab == 1 }"
              >门诊发票</span
            >
            <span
              class="one-span"
              @click="getEightChild(2)"
              :class="{ active: showChildTab == 2 }"
              >体检发票</span
            >
          </div>
          <!-- <div class="search-box-two">
            <span class="three-span">时间：</span>
            <a-date-picker class="time-picker" v-model="startDate" valueFormat="YYYY-MM-DD"  placeholder="请选择"/>
            <div class="search-div" @click="searchConsume">查询</div>
          </div> -->
          <div class="table mobile-table">
            <div class="table-one-tab" v-if="showChildTab == 1">
              <ul
                v-for="(item, index) in invoiceDataOne"
                :key="item.patientNo + index"
              >
                <li>
                  <span class="one-span">就诊日期:</span
                  ><span class="two-span">{{ item.payDate }}</span>
                </li>
                <li>
                  <span class="one-span">科室:</span
                  ><span class="two-span">{{ item.deptName }}</span>
                </li>
                <li>
                  <span class="one-span">医生:</span
                  ><span class="two-span">{{ item.doctorName }}</span>
                </li>
                <li>
                  <span class="one-span">费用:</span
                  ><span class="two-span">{{ item.totalFee }}</span>
                </li>
                <li>
                  <span class="one-span">操作:</span>
                  <span class="two-span">
                    <a @click="reviewInvoice(item.pdfUrl)" class="btn">预览</a>
                    <!-- <a @click="downloadInvoice(item.pdfUrl)" class="btn">下载</a> -->
                  </span>
                </li>
              </ul>
            </div>
            <div class="table-two-tab" v-if="showChildTab == 2">
              <ul
                v-for="(item, index) in invoiceDataTwo"
                :key="item.visitId + index"
              >
                <li>
                  <span class="one-span">体检日期:</span
                  ><span class="two-span">{{ item.name }}</span>
                </li>
                <li>
                  <span class="one-span">体检套餐:</span
                  ><span class="two-span">{{ item.totalFee }}</span>
                </li>
                <li>
                  <span class="one-span">费用:</span
                  ><span class="two-span">{{ item.regDate }}</span>
                </li>
              </ul>
              <a-pagination
                @change="pageChange"
                :current="pagination.current"
                :pageSize="10"
                :total="pagination.total"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 电子发票 end -->
    </div>

    <a-modal
      v-model="cancelSubscribeVisible"
      title="提示"
      @ok="handleCancelSubscribeOk"
      okText="确定"
      cancelText="取消"
    >
      <div>
        是否取消预约？
      </div>
    </a-modal>

    <a-modal
      v-model="returnNumVisible"
      title="提示"
      @ok="handleReturnNumOk"
      okText="确定"
      cancelText="取消"
    >
      <div>
        是否退号？
      </div>
    </a-modal>

    <a-modal
      v-model="cancelMakeAnAppointmentVisible"
      title="提示"
      @ok="handleCancelMakeAnAppointmentOk"
      okText="确定"
      cancelText="取消"
    >
      <div>
        是否取消预约？
      </div>
    </a-modal>

    <!-- 支付弹窗 begin -->
    <div class="wemsk" v-show="paymentVisible"></div>
    <div class="pay-model-box" v-show="paymentVisible">
      <div class="pay-main-box">
        <div class="title">
          <div v-if="radioValue == 1" class="top-title">
            挂号成功<span class="close-span" @click="closePaymentModal">x</span>
          </div>
          <div v-if="radioValue == 2" class="top-title">
            预约成功<span class="close-span" @click="closePaymentModal">x</span>
          </div>
          <div v-if="radioValue == 1" class="two-box">
            您预约的{{
              paymentRecord.hisDeptName + paymentRecord.hisDoctorName + '医生'
            }}<span>{{ paymentRecord.orderTime }}</span
            >挂号成功
          </div>
          <div v-if="radioValue == 2" class="two-box">
            您预约的<span>{{ examBookTime }}</span
            >{{ examBooKMail }}预约成功
          </div>
          <div
            v-if="(radioValue == 1 && breakStatus == 1) || radioValue == 2"
            class="three-box"
          >
            请于<span>30分钟</span>内完成支付，如在有效期内未完成支付，将自动为您取消预约
          </div>
        </div>
        <div class="pay-money">
          应付金额：<span>{{ paymentRecord.fee }}</span
          >元
        </div>
        <div class="img-box">
          <div class="left-img-box">
            <div class="qrcode-box">
              <div id="qrcode"></div>
            </div>
            <div class="bottom-remind-box">
              <img class="img" src="../images/sm.png" alt="" />
              <div class="txt">请使用微信、支付宝<br />扫码支付</div>
            </div>
          </div>
          <div class="right-img-box">
            <img src="../images/payBg.png" alt="" />
          </div>
        </div>
        <div class="red-txt-box">
          <div class="content-red-box">
            <img src="../images/gth.png" alt="" />
            距离二维码过期还剩<span>{{ num }}</span
            >秒，过期后请重新获取二维码
          </div>
        </div>
      </div>
    </div>
    <!-- 支付弹窗 end -->

    <!-- 支付成功弹窗 begin -->
    <div class="wemsk" v-show="paySuccessVisible"></div>
    <div class="pay-success-model-box" v-show="paySuccessVisible">
      <div class="top-title">
        支付成功<span class="close-span" @click="closePaySuccessModel">x</span>
      </div>
      <div class="middle-box">
        <img src="../images/success.png" alt="" />
        您已成功付款<span>{{ paymentFee }}</span
        >元
      </div>
      <div class="bottom-box">
        <span>{{ paySuccessNum }}</span
        >s后自动关闭
      </div>
    </div>
    <!-- 支付成功弹窗 end -->

    <!-- 手机支付选择弹框 -->
    <div v-if="selectPayPhoneVisible">
      <div class="wemsk"></div>
      <div class="pay-success-model-box">
        <div class="top-title">请选择支付方式</div>
        <div class="payRadioGroup">
          <a-radio-group v-model="paySelectValue" @change="onChangePayMethod">
            <!-- <a-radio class="payMethodRadio" style="display:block; width:100%; height:30px;" :value="1">
              <div style="display:flex">
                <img style="width:20px; margin-left:20px; margin-right:10px" src="../images/wxpay.png" alt="" />
                <span>微信支付</span>
              </div>
            </a-radio> -->
            <a-radio
              class="payMethodRadio"
              style="display:block; width:100%; height:30px; margin-top:10px"
              :value="2"
            >
              <div style="display:flex">
                <img
                  style="width:20px; margin-left:20px; margin-right:10px"
                  src="../images/alipay.png"
                  alt=""
                />
                <span>支付宝支付</span>
              </div>
            </a-radio>
          </a-radio-group>
        </div>
        <div style="text-align:center">
          <a-button type="primary" @click="payMenthodConfirm">确定</a-button>
        </div>
      </div>
    </div>

    <!-- 手机支付中弹框 -->
    <div v-if="payPhoneVisible">
      <div class="wemsk"></div>
      <div class="pay-success-model-box">
        <div class="top-title">
          支付中<span class="close-span" @click="closePayPhoneModal">x</span>
        </div>
        <div class="middle-box">
          <!-- <img src="../images/success.png" alt=""> -->
          请于30分钟内完成支付，如在有效期内未完成支付，将自动为您取消预约
        </div>
        <div class="bottom-box">
          <span>{{ num }}</span
          >s后自动关闭，请重新获取支付链接
        </div>
      </div>
    </div>

    <!-- 是否支付完成弹窗begin -->
    <div class="wemsk" v-if="showHasPaySuccess"></div>
    <div class="has-pay-success" v-if="showHasPaySuccess">
      <div class="gth-box">
        <div class="gth">
          !
        </div>
      </div>
      <div class="txt">请确认是否支付完成</div>
      <div class="btn-box">
        <p @click="refreshPay">重新支付</p>
        <p class="red-btn" @click="hasPaySuccess">已完成支付</p>
      </div>
    </div>
    <!-- 是否支付完成弹窗end -->

    <!-- 发票预览弹窗 begin -->
    <!-- <div class="wemsk" v-show="showInvoice"></div>
    <div class="pay-success-model-box" v-show="showInvoice">
      <div class="top-title">发票预览<span class="close-span" @click="closeInvoiceModel">x</span></div>
      <div class="middle-box">
        <img style="width:500px;height:300px" :src="invoiceSrc" alt="">
      </div>
    </div> -->
    <!-- 发票预览弹窗 end -->

    <div class="iframe-box" v-if="showIframe">
      <span class="close-span" @click="showIframe = false">X</span>
      <iframe
        width="100%"
        height="100%"
        :src="iframeSrc"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { JSEncrypt } from 'jsencrypt'
import moment from 'moment'
import { MIC_CONFIG } from "@/utils/constant";
import{ encryptByDES, checkIdNo, checkPhoneNo, checkIdTypes } from '@/utils/index';
import AddPersonAgreement from "@/components/hospitalPersonalList/addPersonAgreement"

const consultantColumns = [
  {
    title: '姓名',
    dataIndex: 'name',
    width: '10%',
  },
  {
    title: '诊疗卡号',
    dataIndex: 'cardNo',
    width: '15%',
  },
  {
    title: '证件号',
    dataIndex: 'idNoHide',
    width: '20%',
  },
  {
    title: '手机号',
    dataIndex: 'phoneHide',
    width: '15%',
  },
  {
    title: '关系',
    dataIndex: 'relationshipCode',
    width: '10%',
    scopedSlots: { customRender: 'relationshipCode' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: '15%',
    scopedSlots: { customRender: 'action' },
  },
]
let consultantData = []
const outpatientColumns = [
  {
    title: '就诊科室',
    dataIndex: 'hisDeptName',
    width: '15%',
  },
  {
    title: '医师',
    dataIndex: 'hisDoctorName',
    width: '10%',
  },
  {
    title: '订单号',
    dataIndex: 'orderNo',
    width: '15%',
  },
  {
    title: '预约时间',
    dataIndex: 'visitTime',
    width: '25%',
  },
  {
    title: '状态',
    dataIndex: 'payStatus',
    width: '15%',
    scopedSlots: { customRender: 'payStatus' },
  },
]
let outpatientData = []
const medicalColumns = [
  {
    title: '体检科室',
    dataIndex: 'hisDeptDesc',
    width: '15%',
  },
  {
    title: '体检套餐',
    dataIndex: 'packageName',
    key: 'packageName',
    width: '15%',
  },
  {
    title: '体检等级',
    dataIndex: 'levelDesc',
    width: '15%',
  },
  {
    title: '预约体检时间',
    dataIndex: 'reserveDate',
    key: 'reserveDate',
    scopedSlots: { customRender: 'reserveDate' },
    width: '25%',
  },
  {
    title: '状态',
    dataIndex: 'reserveStatus',
    width: '20%',
    scopedSlots: { customRender: 'reserveStatus' },
  },
]
let medicalData = []
const reportOneColumns = [
  {
    title: '名称',
    dataIndex: 'fileName',
    width: '15%',
  },
  {
    title: '科室名称',
    dataIndex: 'hisDeptName',
    width: '15%',
  },
  {
    title: '时间',
    dataIndex: 'reportDate',
    width: '15%',
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: '20%',
    scopedSlots: { customRender: 'action' },
  },
]
const reportTwoColumns = [
  {
    title: '名称',
    dataIndex: 'examTitle',
    width: '15%',
  },
  {
    title: '科室',
    dataIndex: 'hisDeptName',
    width: '15%',
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: '20%',
    scopedSlots: { customRender: 'action' },
  },
]
let reportOneData = []
let reportTwoData = []
const statementColumnsOne = [
  // {
  //   title: '病人费别',
  //   dataIndex: 'feeType',
  //   width: '15%',
  // },
  // {
  //   title: '科室',
  //   dataIndex: 'dept',
  //   width: '15%',
  // },
  // {
  //   title: '病区',
  //   dataIndex: 'ward',
  //   width: '15%',
  // },
  // {
  //   title: '总费用',
  //   dataIndex: 'totalFee',
  //   width: '15%',
  // },
  // {
  //   title: '当日总计',
  //   dataIndex: 'todayFee',
  //   width: '15%',
  // },
  // {
  //   title: '余额',
  //   dataIndex: 'balance',
  //   width: '15%',
  // },
  {
    title: '账单号',
    dataIndex: 'billNo',
    width: '15%',
  },
  {
    title: '账单日期',
    dataIndex: 'billDate',
    width: '15%',
  },
]
let statementDataOne = []
const statementColumnsTwo = [
  {
    title: '票据流水号',
    dataIndex: 'orderNo',
    width: '15%',
  },
  {
    title: '消费日期',
    dataIndex: 'payDate',
    width: '15%',
  },
  {
    title: '票据总金额',
    dataIndex: 'receiptSum',
    width: '15%',
  },
  {
    title: '就诊日期',
    dataIndex: 'visitDate',
    width: '15%',
  },
  {
    title: '就诊科室',
    dataIndex: 'visitDept',
    width: '15%',
  },
  {
    title: '就诊医生',
    dataIndex: 'visitDoctor',
    width: '15%',
  },
]
let statementDataTwo = []
let consultantForm = {
  sys: 'ohealth',
  hospitalCode: 'H02',
  name: '',
  phone: '',
  idType: '01',
  idNo: '',
  birthday: '',
  gender: '1',
  relation: '0',
  verifyCode: '',
  source: 'WEB',
  agreeCheck: false,
  agree360Check: false,
}
export default {
  name: 'personlist-001-hf',
  components: {
    AddPersonAgreement,
  },
  data() {
    return Object.assign({
      paySeq: '',
      orderCode1: '', // 此处orderCode1只做退号入参用
      visitId: '',
      publicKey: '',
      consultantData,
      consultantColumns,
      outpatientData,
      outpatientColumns,
      medicalData,
      medicalColumns,
      reportOneColumns,
      reportTwoColumns,
      reportOneData,
      reportTwoData,
      statementDataOne,
      statementColumnsOne,
      statementDataTwo,
      statementColumnsTwo,
      invoiceColumnsOne: [
        {
          title: '就诊日期',
          dataIndex: 'payDate',
          width: '15%',
        },
        {
          title: '科室',
          dataIndex: 'deptName',
          width: '15%',
        },
        {
          title: '医生',
          dataIndex: 'doctorName',
          width: '15%',
        },
        {
          title: '金额',
          dataIndex: 'totalFee',
          width: '15%',
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '15%',
          scopedSlots: { customRender: 'action' },
        },
      ],
      invoiceColumnsTwo: [
        {
          title: '体检日期',
          dataIndex: 'rq',
          width: '15%',
        },
        {
          title: '套餐',
          dataIndex: 'tc',
          width: '15%',
        },
        {
          title: '金额',
          dataIndex: 'je',
          width: '15%',
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '15%',
          scopedSlots: { customRender: 'action' },
        },
      ],
      invoiceDataOne: '',
      invoiceDataTwo: '',
      activeBox: 1,
      showChildTab: 1,
      showReport: 1,
      visiblePc: false,
      confirmLoading: false,
      zjTypeList: [
        {
          id: '01',
          name: '居民身份证',
        },
        {
          id: '03',
          name: '护照',
        },
        {
          id: '06',
          name: '港澳居民来往内地通行证',
        },
        {
          id: '07',
          name: '台湾居民来往内地通行证',
        },
        {
          id: '13',
          name: '外国人永久居留身份证'
        },
      ],
      activeZjType: '01',
      genderList: [
        {
          name: '男',
          id: '1',
        },
        {
          name: '女',
          id: '2',
        },
      ],
      activeGender: '1',
      relationshipList: [
        {
          id: '0',
          name: '本人',
        },
        {
          id: '1',
          name: '子女',
        },
        {
          id: '2',
          name: '父母',
        },
        {
          id: '3',
          name: '夫妻',
        },
        {
          id: '4',
          name: '其它',
        },
      ],
      activeRelationship: '0',
      visibleMobile: false,
      cbVisible: false,
      reportTypeList: [
        {
          id: '01',
          name: '检验报告',
        },
        {
          id: '02',
          name: '检查报告',
        },
        {
          id: '03',
          name: '体检报告',
        },
      ],
      activeReportType: '01',
      txt:
        '医院数字化涵盖数字化医疗、数字化运营、数字化营销、数字化服务四大核心业务模块，其中数字化医疗技术极大的突破了时间与空间的界限，大大增强了患者与医院之间的联接，无论是在家中，还是在工作场所都可以随时随地与医院建立联系，提高了医疗服务的可及性与便利性，为医务人员诊疗活动提供高效的技术与流程支撑',
      activeTab: 1,
      consultantForm,
      activeCancelPeople: {
        // 当前解绑人信息
        id: null, // 当前解绑人id
        relationshipCode: 0, // 当前解绑人relationshipCode
        relation: '', // 当前解绑人relation
        hospitalCode: 'H02',
      },
      activeHisPatientId: '0',
      reportForm: {},
      consultantPeopleList: [],
      cancelSubscribeVisible: false,
      cancelSubscribeOrderCode: '',
      returnNumVisible: false,
      returnNumVisited: '',
      returnNumOrderCode: '',
      activeReportVisitId: '',
      cancelMakeAnAppointmentVisible: false,
      cancelMakeAnAppointmentReserveId: '',
      cancelMakeAnAppointmentHisPatientId: '',
      examBookItem: {},
      reportTypeTab: 1,
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      pagination: {
        // 已缴费记录分页设置
        current: 1,
        pageSize: 10,
        change: this.pageChange,
        total: 0,
      },
      iframeSrc: '',
      showIframe: false,

      paymentVisible: false, // 显示支付弹框
      paymentQrCode: '', // 二维码显示链接
      paymentRecord: {
        // 一条数据信息
        hisDeptName: '',
        hisDoctorName: '',
        orderTime: '',
        fee: '',
        orderCode: '',
      },
      timer: '', // 定时器
      num: 120, // 时长
      showPayModel: false,
      showPaySuccessModel: false,
      paymentFee: '', // 支付金额
      paySuccessNum: 5, // 支付成功展示时间
      radioValue: 1, // 1门诊预约，2体检预约
      payPhoneVisible: false, // 手机支付弹框显示
      mineInfo: {}, //本人的信息
      activePerson: {}, // 目前选中的就诊人
      hospitalCode: 'H02',
      paySuccessTimer: '', // 支付成功计时器
      paySuccessVisible: false, // 显示支付成功
      examBooKMail: '', // 体检预约套餐
      examBookTime: '', // 体检预约时间
      showHasPaySuccess: false, // 手机端是否支付完成
      yzmTxt: '获取验证码', // 获取验证码内容
      yzmNum: 120, // 验证码倒计时
      yzmTimer: null, // 验证码计时器
      isShowMzFeeDialog: true, // 门诊支付是否可以点击计费弹窗
      isShowTjFeeDialog: true, // 体检支付是否可以点击计费弹窗
      // showInvoice: false,
      // invoiceSrc: '',

      selectPayPhoneVisible: false,
      paySelectValue: 2, // 手机端目前只有支付宝支付，初始为支付宝支付
      payMethodValue: 'alipay', // 手机端目前只有支付宝支付，初始为支付宝支付

      breakStatus: 0, // 预约文案  0：不显示；1：显示
      packagePrice: 0, // 体检套餐价格
      // 会员订单列表
      vipOrderColumns: [
        {
          title: '订单编号',
          dataIndex: 'name',
          width: '10%',
        },
        {
          title: '客户',
          dataIndex: 'name',
          width: '10%',
        },
        {
          title: '医院',
          dataIndex: 'name',
          width: '10%',
        },
        {
          title: '有效开始日期',
          dataIndex: 'name',
          width: '10%',
        },
        {
          title: '有效结束日期',
          dataIndex: 'name',
          width: '10%',
        },
        {
          title: '开单科室',
          dataIndex: 'name',
          width: '10%',
        },
        {
          title: '优惠总金额',
          dataIndex: 'name',
          width: '10%',
        },
        {
          title: '总金额',
          dataIndex: 'name',
          width: '10%',
        },
      ],
      vipOrderData: [],
      // 卡券列表
      cardColumns: [
        {
          title: '券号',
          dataIndex: 'couponNumber',
          width:150
        },
        {
          title: '类型',
          dataIndex: 'couponType',
          scopedSlots: { customRender: 'couponType' },
        },
        {
          title: '面额',
          dataIndex: 'couponValue',
        },
        {
          title: '折扣',
          dataIndex: 'couponDiscount',
        },
        {
          title: '有效开始日期',
          dataIndex: 'startDate',
        },
        {
          title: '有效结束日期',
          dataIndex: 'endDate',
        },
        {
          title: '状态',
          dataIndex: 'couponStatus',
          scopedSlots: { customRender: 'couponStatus' },
        }
      ],
      cardData: [],
      cardForm: {
        counpNo: '',
        hisPatientId: '',
      },
      cardVisiblePc: false,
      // 360健康视图
      mic: {},
    })
  },
  created() {
    this.getPublicKey()
    // this.getNationList();
    let callback=null
    this.activeCancelPeople.hospitalCode = this.hospitalCode
    let href = this.$route.hash
    if (href.indexOf('#') > -1) {
      let index = href.split('#')[1]
      const fun = ()=>{ this.changeTab(index)}
      callback=index < 8 && fun
    }
    this.getConsultantList(callback)
  },
  mounted() {
    this.getMicUsing() // 360个人知情同意书-当前再用信息

    // let data = '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'
    // + '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'
    // + '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'
    // + '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'
    // + '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'
    // + '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'
    // + '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'
    // + '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'
    // + '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'
    // + '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'
    // + 'tKS9TdXBwbGVtZW50IDQ+Pi9UeXBlL0ZvbnQvV1sxWzIwN10gNls3OTddIDkgMTAgMzc0IDExWzQyM10gMTRbMzc1IDIzOCAzMzRdIDE3IDI2IDQ2MiAyN1syMzhdIDM0WzY4NF0gNDlbNTQ0XSA1Nls5NzIgNjQ3XV0vU3VidHlwZS9DSURGb250VHlwZTAvRm9udERlc2NyaXB0b3IgMjkgMCBSL0RXIDEwMDA+PgplbmRvYmoKMzAgMCBvYmoKPDwvRmllbGRzWzIzIDAgUl0vRFI8PD4+L0RBKAAnunRuBWEXMt5cYh3j1cfKruu21bpNj9vJf8fu5xq/cikvU2lnRmxhZ3MgMz4+CmVuZG9iago2IDAgb2JqCjw8L1Blcm1zPDwvRG9jTURQIDEgMCBSPj4vVHlwZS9DYXRhbG9nL0Fjcm9Gb3JtIDMwIDAgUi9QYWdlcyAyMCAwIFI+PgplbmRvYmoKMzEgMCBvYmoKPDwvU3RyRi9TdGRDRi9DRjw8L1N0ZENGPDwvQ0ZNL0FFU1YyL0F1dGhFdmVudC9Eb2NPcGVuL0xlbmd0aCAxNj4+Pj4vU3RtRi9TdGRDRi9VICiUM7mAzjhINiKDe/VS5MlnAAAAAAAAAAAAAAAAAAAAACkvTGVuZ3RoIDEyOC9WIDQvTyAo+KXMK9Qb6w+r/6/L279Ti+SrlWlcdMquwiKMLy7C850UKS9QIC0xODUyL0ZpbHRlci9TdGFuZGFyZC9SIDQ+PgplbmRvYmoKeHJlZgowIDMyCjAwMDAwMDAwMDAgNjU1MzUgZiAKMDAwMDAwMDAxNSAwMDAwMCBuIAowMDAwMDAyMjgwIDAwMDAwIG4gCjAwMDAwMDMwOTcgMDAwMDAgbiAKMDAwMDAwMjgwMSAwMDAwMCBuIAowMDAwMDAyNTI5IDAwMDAwIG4gCjAwMDAwNDkwMzEgMDAwMDAgbiAKMDAwMDAwMzMzMSAwMDAwMCBuIAowMDAwMDAzNTgzIDAwMDAwIG4gCjAwMDAwMDQxNTQgMDAwMDAgbiAKMDAwMDAxMzI0OCAwMDAwMCBuIAowMDAwMDQ4NjIxIDAwMDAwIG4gCjAwMDAwMTMzNzQgMDAwMDAgbiAKMDAwMDAzNDAxMiAwMDAwMCBuIAowMDAwMDM0MzQ4IDAwMDAwIG4gCjAwMDAwMTM1MDggMDAwMDAgbiAKMDAwMDA0NzY2NCAwMDAwMCBuIAowMDAwMDQ4MDA1IDAwMDAwIG4gCjAwMDAwMTM2NDUgMDAwMDAgbiAKMDAwMDAxNTU4MCAwMDAwMCBuIAowMDAwMDMxODQ4IDAwMDAwIG4gCjAwMDAwMzAyNDMgMDAwMDAgbiAKMDAwMDAxNjEzNiAwMDAwMCBuIAowMDAwMDMwMDg1IDAwMDAwIG4gCjAwMDAwMTU4MjkgMDAwMDAgbiAKMDAwMDAzMTk0MSAwMDAwMCBuIAowMDAwMDMzODMxIDAwMDAwIG4gCjAwMDAwMzQ3MjAgMDAwMDAgbiAKMDAwMDA0NzQ3NiAwMDAwMCBuIAowMDAwMDQ4NDA5IDAwMDAwIG4gCjAwMDAwNDg5MzkgMDAwMDAgbiAKMDAwMDA0OTExNiAwMDAwMCBuIAp0cmFpbGVyCjw8L1Jvb3QgNiAwIFIvSUQgWzwzY2Y5YmQ0Mjc3MDgyMjM5NWM3ZTE4NjA1NTI4N2Q3Yz48OWQ1MTQ3ZmU0YjlkMzRhYzAyNzcwMDJmYjFmYzYwNzU+XS9FbmNyeXB0IDMxIDAgUi9JbmZvIDcgMCBSL1NpemUgMzI+PgpzdGFydHhyZWYKNDkzMzIKJSVFT0YK'
    // this.reviewInvoice(data);
  },
  methods: {
    pickerOptions(current) {
      return current && (current.valueOf() < new Date('1900', '0', '1').getTime()) || (current.valueOf() > new Date().getTime());
    },
    // 优惠券绑定
    cardAdd() {
      //先校验再激活
      let par = {
        ...this.cardForm,
        hospitalCode: this.hospitalCode,
      }
      if (!par.hisPatientId) {
        this.$message.warning('请选择就诊人')
        return
      }
      if (!par.counpNo) {
        this.$message.warning('请输入券号')
        return
      }
      this.$API.getCardCheck(par).then((res) => {
        if (res.code == 0) {
          this.$API.getCardActive(par).then((res) => {
            if (res.code == 0) {
              this.$message.success('卡券激活成功')
              this.cardVisiblePc = false
              this.getCardList()
            }
          })
        } else {
          this.$message.error('卡券校验失败')
          this.cardVisiblePc = false
          this.getCardList()
        }
      })
    },
    //优惠券绑定页取消
    closeCardBind() {
      this.cardForm = {}
      this.cardVisiblePc = false
    },
    // 获取就诊人再获取门诊预约列表
    getConsultantList1() {
      let data = { hospitalCode: 'H02' }
      this.$API.patientList(data).then((res) => {
        if (res.code == 0) {
          this.consultantData = res.data || []
          if (this.consultantData.length > 0) {
            this.activeHisPatientId = this.consultantData[0].hisId
            this.getOutpatientBookList()
          } else {
            this.activeHisPatientId = 0
            this.getOutpatientBookList()
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取就诊人再获取体检预约列表
    getConsultantList2() {
      let data = { hospitalCode: 'H02' }
      this.$API.patientList(data).then((res) => {
        if (res.code == 0) {
          this.consultantData = res.data || []
          if (this.consultantData.length > 0) {
            this.activeHisPatientId = this.consultantData[0].hisId
            this.getExamBookList()
          } else {
            this.activeHisPatientId = 0
            this.getExamBookList()
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取就诊人列表
    getConsultantList(callback) {
      let ut = localStorage.getItem('ut')
      // localStorage中没有ut，判断是否登录
      if (ut == undefined || ut == null || ut == '') {
        this.$router.push({
          path: '/personalCenter/login',
          query: { redirect: '/personalCenter/personalList' }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
        return
      }
      let data = { hospitalCode: this.hospitalCode }
      this.$API.patientList(data).then((res) => {
        if (res.code == 0) {
          this.consultantData = res.data || []
          if (this.consultantData.length > 0) {
            if(this.activeHisPatientId == 0){
              this.activeHisPatientId = this.consultantData[0].hisId
              this.activePerson = this.consultantData[0]
            }
            // this.activeHisPatientId = this.consultantData[0].hisId
            // this.activePerson = this.consultantData[0]
            callback&&callback()
          } else {
            this.activeHisPatientId = 0
          }
          this.consultantPeopleList = []
          for (let i = 0; i < this.consultantData.length; i++) {
            let obj = {
              id: this.consultantData[i].hisId,
              name: this.consultantData[i].name,
            }
            this.consultantPeopleList.push(obj)
            // 判断是否是本人
            if (this.consultantData[i].relationshipCode == '0') {
              this.mineInfo = this.consultantData[i]
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 加密
    setEncrypt(msg) {
      let jsencrypt = new JSEncrypt({})
      jsencrypt.setPublicKey(this.publicKey)
      return jsencrypt.encrypt(msg)
    },
    // 获取公匙
    getPublicKey() {
      this.$API.rsaPublic().then((res) => {
        if (res.code == 0) {
          this.publicKey = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取验证码
    getYzm() {
      debugger
      if (!this.consultantForm.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      if (this.yzmTxt != '获取验证码') {
        return
      }
      this.yzmTimer = setInterval(() => {
        this.yzmTxt = this.yzmNum + 's'
        this.yzmNum--
        if (this.yzmNum <= 0) {
          this.yzmNum = 120
          this.yzmTxt = '获取验证码'
          clearInterval(this.yzmTimer)
        }
      }, 1000)
      let phone = this.setEncrypt(this.consultantForm.phone)
      let language = this.setEncrypt('zh')
      let purpose = this.setEncrypt('V')
      let sys = this.setEncrypt('ohealth') //合肥sys传h02site,苏州成都传ohealth
      let templateNo = this.setEncrypt('h02-wechat-notify')
      let hospitalCode = this.setEncrypt('H02')
      let obj = {
        phone: phone,
        language: language,
        purpose: purpose,
        sys: sys,
        templateNo: templateNo,
        hospitalCode: hospitalCode,
      }
      debugger
      this.$API.sendCode(obj).then((res) => {
        if (res.code == 0) {
          this.$message.success('获取验证码成功！')
        } else {
          this.$message.error(res.msg)
          this.yzmNum = 120
          this.yzmTxt = '获取验证码'
          clearInterval(this.yzmTimer)
        }
      })
    },
    // 获取门诊预约记录列表
    getOutpatientBookList() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning('无门诊预约记录')
        return
      }
      // const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.activeHisPatientId);
      const encodeEnAes = window.encodeURIComponent(hisPatientId);
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnAes,
        pageNo: 1,
        pageSize: 100,
      }
      this.$API.bookList(data).then((res) => {
        if (res.code == 0) {
          this.outpatientData = res.data || []
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取体检预约记录列表
    getExamBookList() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning('无体检预约记录')
        return
      }
      // hisPatientId
      // const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const enDes = this.setEncrypt(this.activeHisPatientId);
      const encodeEnDes = window.encodeURIComponent(enDes);
      // idNo
      // const idNoEnDes = encryptByDES(this.activePerson.idNo, '6519625babf183f8')
      // const idNoEncodeEnDes = window.encodeURIComponent(idNoEnDes)
      const idNoEnDes = this.activePerson.idNo;
      const idNoEncodeEnDes = window.encodeURIComponent(idNoEnDes);
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        pageNo: 1,
        pageSize: 100,
        idNo: idNoEncodeEnDes,
      }
      this.$API.getExamBookList(data).then((res) => {
        if (res.code == 0) {
          this.medicalData = res.data || []
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取检验、检查报告查询列表
    getReportQueryOne() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning('无报告记录')
        return
      }
      // hisPatientId
      // const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.activeHisPatientId);
      const encodeEnDes = window.encodeURIComponent(hisPatientId);

      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        pageNo: 1,
        pageSize: 100,
        type: this.activeReportType,
        visitId: null,
        genre: null,
      }
      this.$API.getReportQueryOne(data).then((res) => {
        if (res.code == 0) {
          this.reportOneData = res.data || []
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取体检报告查询列表
    getReportQueryTwo() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning('无报告记录')
        return
      }
      // hisPatientId
      // const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.activeHisPatientId);
      const encodeEnDes = window.encodeURIComponent(hisPatientId);
      // idNo
      // const idNoEnDes = encryptByDES(this.activePerson.idNo, '6519625babf183f8')
      // const idNoEncodeEnDes = window.encodeURIComponent(idNoEnDes)
      const idNoEnDes = this.activePerson.idNo
      const idNoEncodeEnDes = window.encodeURIComponent(idNoEnDes)
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        pageNo: 1,
        pageSize: 100,
        idNo: idNoEncodeEnDes,
      }
      debugger
      this.$API.getReportQueryTwo(data).then((res) => {
        if (res.code == 0) {
          this.reportTwoData = res.data || []
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取在院日清明细列表
    getNissinDetailList() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning('无在院日清明细记录')
        return
      }
      // const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.activeHisPatientId);
      const encodeEnDes = window.encodeURIComponent(hisPatientId);
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        // startDate: this.startDate,
        // endDate: this.endDate,
      }
      // debugger
      this.$API.getDailyList(data).then((res) => {
        if (res.code == 0) {
          this.statementDataOne = res.data || []
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取已缴费记录列表
    getAlreadyPayCost() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning('无已缴费记录')
        return
      }
      // const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.activeHisPatientId);
      const encodeEnDes = window.encodeURIComponent(hisPatientId);
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }
      this.$API.getAlreadyPayCost(data).then((res) => {
        if (res.code == 0) {
          debugger
          this.statementDataTwo = res.data || []
          this.pagination.total = res.data.length || 0
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 发票就诊人变化
    invoiceConsultantPeopleChange() {
      if (this.showChildTab == 1) {
        this.getOutpatientInvoiceList()
      } else if (this.showChildTab == 2) {
        this.getExamInvoiceList()
      }
    },

    // 获取门诊发票
    getOutpatientInvoiceList() {
      // const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.activeHisPatientId);
      const encodeEnDes = window.encodeURIComponent(hisPatientId);
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }
      this.$API.getOutpatientInvoiceList(data).then((res) => {
        if (res.code == 0) {
          this.invoiceDataOne = res.data.list || []
          this.pagination.total = res.data.total || 0
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 获取体检发票
    getExamInvoiceList() {
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: this.activeHisPatientId,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }
    },

    // 预览发票
    reviewInvoice(code) {
      code = code.replace(/[\n\r]/g, '')
      var raw = window.atob(code)
      let rawLength = raw.length
      //转换成pdf.js能直接解析的Uint8Array类型
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      let binaryData = []
      binaryData.push(uInt8Array)
      let url = window.URL.createObjectURL(
        new Blob(binaryData, { type: 'application/pdf;charset=UTF-8' })
      )
      this.iframeSrc =
        this.ROUTE_BASE + '/pdf/web/viewer.html?file=' + encodeURIComponent(url)
      this.showIframe = true
    },
    // // 下载发票
    // downloadInvoice(url) {

    // },
    // // 关闭发票预览
    // closeInvoiceModel(){
    //   this.showInvoice = false;
    // },

    // 取消门诊预约
    cancelSubscribe(record) {
      // this.cancelSubscribeOrderCode = orderCode
      // this.cancelSubscribeVisible = true
      let that = this
      this.$confirm({
        title: '提示',
        content: '确认取消预约？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.$API
            .bookCancel({
              hospitalCode: that.hospitalCode,
              orderCode: record.orderNo,
            })
            .then((res) => {
              if (res && res.code == 0) {
                that.getOutpatientBookList()
              }
            })
        },
        onCancel() {},
      })
    },
    // 确认取消门诊预约
    handleCancelSubscribeOk() {
      let data = {
        hospitalCode: this.hospitalCode,
        orderCode: this.cancelSubscribeOrderCode,
      }
      this.$API.bookCancel(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('取消预约成功！')
          this.getOutpatientBookList()
          this.cancelSubscribeVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 门诊预约去支付
    goToPay(record) {
      if (!this.isShowMzFeeDialog) {
        return
      }
      this.isShowMzFeeDialog = false
      this.getBookDetail(record)
      let orderCode = record.orderCode
      let hisPatientId = this.activeHisPatientId
      let fee = record.fee * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentFee = record.fee
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.zIndex = 1000
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.position = 'relative'
      if (this.paymentFee == '0') {
        let data = {
          hospitalCode: this.hospitalCode,
          hisPatientId: hisPatientId,
          orderCode: orderCode,
          payType: 'web',
          source: 'h5',
        }
        this.$API.zeroBook(data).then((res) => {
          console.log('zeroPay res:', res)
          if (res && res.code == '0') {
            this.openPaySuccessModal() // PC端支付成功
          }
        })
      } else {
        let data = {
          sys: 'H02',
          source: 'qr',
          platform: 'wxpay',
          payType: 'web',
          businessId: 'A1',
          businessType: '预约支付',
          productId: orderCode,
          productName: '门诊预约',
          totalFee: fee, // 按分计算，返回值乘以100为元
          buyerId: hisPatientId,
          payId: null,
          openId: null,
          unionId: null,
          bizChannel: 7,
          deptCode: record.hisDeptId,
          // accessType: 10,
        }
        this.$API.goPaySuzhou(data).then((res) => {
          console.log('goPay res:', res)
          if (res && res.code == '0') {
            this.paymentQrCode = res.data.payParams.qrContent
            this.paymentVisible = true
            this.getQrCode()
            this.isShowMzFeeDialog = true
          }
        })
      }
    },

    // 获取门诊预约详情
    getBookDetail(record) {
      let orderCode = record.orderNo
      let hisPatientId = record.hisPatientId
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: hisPatientId,
        orderCode: orderCode,
      }
      this.$API.bookDetail(data).then((res) => {
        this.breakStatus = res.data.breakStatus
        this.paySeq = res.data.paySeq
        this.visitId = res.data.visitId
        this.orderCode1 = res.data.orderNo
      })
    },

    // 生成支付二维码
    getQrCode() {
      this.timer = setInterval(this.clock, 1000)
      let that = this
      console.log('this inside qrcode:', that.paymentQrCode)
      let qrcode = require('qrcodejs2')
      document.getElementById('qrcode').innerHTML = ''
      new qrcode(document.getElementById('qrcode'), {
        text: that.paymentQrCode,
        width: 184,
        height: 184,
        correctLevel: qrcode.CorrectLevel.Q,
      })
    },
    // 计时器
    clock() {
      if (this.num > 0) {
        if (this.num % 2 != 0) {
          if (this.radioValue == 1) {
            this.checkPaymentStatus() // 检查门诊预约支付状态
          }
          if (this.radioValue == 2) {
            this.checkExamPaymentStatus() // 检查体检预约支付状态
          }
        }
        this.num--
      } else {
        clearInterval(this.timer)
        this.num = 120
        if (this.radioValue == 1) {
          this.goToPay(this.paymentRecord) // 门诊预约重新支付
        }
        if (this.radioValue == 2) {
          this.immediatelyPay(this.paymentRecord) // 体检预约重新支付
        }
      }
    },
    // 查询门诊支付状态
    checkPaymentStatus() {
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: this.activeHisPatientId,
        orderCode: this.paymentRecord.orderCode,
      }
      this.$API.checkPaymentStatus(data).then(
        (res) => {
          console.log('checkPaymentStatus res:', res)
          if (res && res.code == '0') {
            this.showHasPaySuccess = false
            if (res.data == 'P') {
              this.getOutpatientBookList()
              if (this.SCREEN.mobile) {
                this.closePayPhoneModal() // 关闭手机端
              } else {
                this.closePaymentModal() // 关闭PC端
              }
              this.openPaySuccessModal()
            }
          }
        },
        (error) => {
          console.log('checkPaymentStatus error:', error)
          if (this.SCREEN.mobile) {
            this.closePayPhoneModal()
          } else {
            this.closePaymentModal()
          }
          this.showHasPaySuccess = false
        }
      )
    },
    // 检查体检预约支付状态
    checkExamPaymentStatus() {
      // hisPatientId
      // const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.activeHisPatientId);
      const encodeEnDes = window.encodeURIComponent(hisPatientId);
      // idNo
      // const idNoEnDes = encryptByDES(this.mineInfo.idNo, '6519625babf183f8')
      const idNoEnDes = this.mineInfo.idNo
      const idNoEncodeEnDes = window.encodeURIComponent(idNoEnDes)
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        idNo: idNoEncodeEnDes,
        idType: this.mineInfo.idType,
        reserveNetId: this.paymentRecord.reserveId,
      }
      this.$API.checkExamPaymentStatus(data).then(
        (res) => {
          console.log('checkExamPayStatus res:', res)
          if (res && res.code == '0') {
            this.showHasPaySuccess = false
            if (res.data == '1') {
              this.getExamBookList()
              this.closePaymentModal()
              this.openPaySuccessModal()
            }
          }
        },
        (error) => {
          console.log('checkExamPaymentStatus error:', error)
          if (this.SCREEN.mobile) {
            this.closePayPhoneModal()
          } else {
            this.closePaymentModal()
          }
          this.showHasPaySuccess = false
        }
      )
    },
    // 关闭手机支付中弹框
    closePayPhoneModal() {
      this.payPhoneVisible = false
      clearInterval(this.timer)
      this.num = 120
    },
    // 门诊预约退号
    returnNum(record) {
      this.returnNumOrderCode = record.orderCode
      this.returnNumVisited = record.visitId
      // this.returnNumVisible = true
      debugger
      this.getBookDetail(record)
      let that = this
      this.$confirm({
        title: '提示',
        content: '确认退号？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.$API
            .bookRefund({
              organ: 'PC',
              hospitalCode: that.hospitalCode,
              orderCode: that.orderCode1,
              visitId: that.visitId,
              paySeq: that.paySeq,
              refundFlag: 'TF',
            })
            .then((res) => {
              debugger
              if (res && res.code == 0) {
                that.getOutpatientBookList()
              }
            })
        },
        onCancel() {},
      })
    },
    // 确认退号
    handleReturnNumOk() {
      let data = {
        hospitalCode: this.hospitalCode,
        orderCode: this.returnNumOrderCode,
        visitId: this.returnNumVisited,
      }
      this.$API.bookRefund(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('退号成功！')
          this.getOutpatientBookList()
          this.returnNumVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 预约记录
    makeAnAppointmentRocord(activeHisPatientId) {
      this.activeHisPatientId = activeHisPatientId
      this.activeBox = 4
      this.activeTab = 4
      this.getOutpatientBookList()
    },
    // 门诊预约下拉人选择
    outpatientPeopleChange(value) {
      // this.activeHisPatientId =  value;
      for (let i = 0; i < this.consultantData.length; i++) {
        if (this.consultantData[i].hisId == value) {
          this.activePerson = this.consultantData[i]
        }
      }
      this.getOutpatientBookList()
    },
    // 会员权益下拉人选择
    outpatientPeopleChangeforVIP(value) {
      // this.activeHisPatientId =  value;
      for (let i = 0; i < this.consultantData.length; i++) {
        if (this.consultantData[i].hisId == value) {
          this.activePerson = this.consultantData[i]
        }
      }
      this.getVipList()
    },
    // 优惠券下拉人选择
    outpatientPeopleChangeforConpon(value) {
      // this.activeHisPatientId =  value;
      for (let i = 0; i < this.consultantData.length; i++) {
        if (this.consultantData[i].hisId == value) {
          this.activePerson = this.consultantData[i]
        }
      }
      this.getCardList()
    },
    // 体检预约下拉人选择
    medicalAppointmentPeopleChange(value) {
      // this.activeHisPatientId =  value;
      // this.activePerson = this.consultantData.map(item=>{
      //   if(item.hisId == value){
      //     return item
      //   }
      // })
      for (let i = 0; i < this.consultantData.length; i++) {
        if (this.consultantData[i].hisId == value) {
          this.activePerson = this.consultantData[i]
        }
      }
      this.getExamBookList()
    },
    // 打开pc新增就诊人弹窗
    addPcConsultantPeople() {
      const len = this.consultantData.length;
      if(len >= 9) {
        this.$message.warning(`只可添加9个就诊人`);
        return false;
      }
      this.visiblePc = true
    },
    // 关闭pc新增就诊人弹窗
    closePcConsultantPeople() {
      console.log('closePcConsultantPeople:')
      this.visiblePc = false
      this.consultantForm = {
        sys: 'ohealth',
        hospitalCode: this.hospitalCode,
        name: '',
        phone: '',
        idType: '01',
        idNo: '',
        birthday: '',
        gender: '1',
        relation: '0',
        verifyCode: '',
        source: 'web',
      }
    },
    // 清空就诊人表单
    resetConsultantForm() {
      this.consultantForm = {
        sys: 'ohealth',
        hospitalCode: 'H02',
        name: '',
        phone: '',
        idType: '01',
        idNo: '',
        birthday: '',
        gender: '1',
        relation: '0',
        verifyCode: '',
        source: 'WEB',
        agreeCheck: false,
        agree360Check: false,
      };
    },
    // 打开手机端新增就诊人弹窗
    addMobileConsultantPeople() {
      this.visibleMobile = true
    },
    // 打开手机端新增就诊人弹窗
    closeMobileConsultantPeople() {
      this.visibleMobile = false
      this.consultantForm = {
        sys: 'ohealth',
        hospitalCode: this.hospitalCode,
        name: '',
        phone: '',
        idType: '01',
        idNo: '',
        birthday: '',
        gender: '1',
        relation: '0',
        verifyCode: '',
        source: 'web',
      }
    },
    // 查询个人知情同意书在用信息
    getMicUsing() {
      const _this = this
      this.$API.getMicUsingSingle({
        hospitalCode: 'H02'
      }).then((res) => {
        if (res.code == 0 && res.data) {
          _this.mic = res.data;
        }
      });
    },
    // 新增就诊人确定
    async handleConsultantOk() {
      const _this = this
      if (!this.consultantForm.agreeCheck) {
        this.$message.warning('请先阅读并同意相关协议')
        return
      }
      if (!this.consultantForm.name) {
        this.$message.error('请输入姓名');
        return false;
      }
      if (this.consultantForm.idType == "01") {
        if (!checkIdNo(this.consultantForm.idNo)) {
          this.$message.error('身份证号格式错误，请检查后输入');
          return false;
        }
      }else if (this.consultantForm.idType == "13") {
        const p = /(^[A-Za-z0-9]{15}|^[A-Za-z0-9]{18})$/;
        if (!p.test(this.consultantForm.idNo)) {
          this.$message.error("证件号格式错误，请输入15或18位证件号");
          return false;
        }
      } else {
        if (!checkIdTypes(this.consultantForm.idNo)) {
          this.$message.error('证件号格式错误，仅支持数字,字母');
          return false;
        }
      }
      if (!this.consultantForm.birthday) {
        this.$message.error('请选择出生日期');
        return false;
      }
      if (!checkPhoneNo(this.consultantForm.phone)) {
        this.$message.error('手机号码格式错误，请检查后重新输入');
        return false;
      }
      const Today = new Date(new Date().toLocaleString().split(" ")[0]).getTime();
      const getBirthday = new Date(this.consultantForm.birthday.replaceAll('-','/')).getTime();
      // 判断当前日期跟出生日期
      if (getBirthday > Today) {
        this.$message.error('出生日期不能晚于当前日期');
        return false;
      }
      
      this.confirmLoading = true
      console.log('新增就诊人表单', this.consultantForm)
      
      try {
        let phone = this.setEncrypt(this.consultantForm.phone);
        let idNo = this.setEncrypt(this.consultantForm.idNo);
        const addParams = JSON.parse(JSON.stringify({
          ...this.consultantForm,
          phone,
          idNo,
        }))
        let addRes = await this.$API.addPatient(addParams);
        if (addRes.code == 0) {
          this.$message.success("新增成功！");
          const signStatus = _this.consultantForm.agree360Check ? "1" : "0";
          this.visiblePc = false;
          this.visibleMobile = false;
          this.getConsultantList();
          // TODO: 360视图 0---
          /* // 去签署
          const sendMsg = {
            hospitalCode: _this.hospitalCode,
            hisId: addRes.data,
            patientName: _this.consultantForm.name,
            micId: _this.mic.id,
            micVersion: _this.mic.micVersion,
            signStatus,
            secondSource: MIC_CONFIG.source, // 正式：boegw  测试：GW
          }
          console.log('360视图 0', sendMsg)
          const micSignRes = await this.$API.getMicSignSingle(sendMsg); */
          // TODO: 360视图 1---
        } else {
          this.$message.error(res.msg);
        }
        this.confirmLoading = false;
        console.log("执行this.confirmLoading", this.confirmLoading);
      } catch (error) {
        this.confirmLoading = false;
      }
    },
    // 解绑弹窗
    cancelBind(id, relationshipCode, relation) {
      this.cbVisible = true
      this.activeCancelPeople.id = id
      this.activeCancelPeople.relationshipCode = relationshipCode
      this.activeCancelPeople.relation = relation
    },
    // 确认解绑
    handleCbOk() {
      this.$API.patientDel(this.activeCancelPeople).then((res) => {
        if (res.code == 0) {
          this.$message.success('删除成功！')
          this.getConsultantList()
        } else {
          this.$message.error(res.msg)
        }
      })
      this.cbVisible = false
    },
    // 取消解绑
    handleCbCancel() {
      this.cbVisible = false
    },
    // 体检预约记录-取消预约
    cancelMakeAnAppointment(record) {
      // this.cancelMakeAnAppointmentReserveId = reserveId;
      this.hisPatientId = record.hisPatientId
      this.examBookItem = record
      // this.cancelMakeAnAppointmentVisible = true
      let that = this
      this.$confirm({
        title: '提示',
        content: '确认取消预约？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.$API
            .cancelExamBook({
              hospitalCode: 'H02',
              hisPatientId: that.hisPatientId,
              idNo: record.idNo,
              idType: record.idType,
              reserveNetId: record.reserveNetId,
              visitId: record.visitId,
            })
            .then((res) => {
              debugger
              if (res && res.code == 0) {
                that.getExamBookList()
              }
            })
        },
        onCancel() {},
      })
    },
    // 体检预约记录-确认取消预约
    handleCancelMakeAnAppointmentOk() {
      let data = {
        hospitalCode: this.hospitalCode,
        reserveId: this.examBookItem.reserveId,
        reserveDate: this.examBookItem.reserveTime,
        packageName: this.examBookItem.packageName,
        hisPatientId: this.activePerson.hisId,
      }
      this.$API.cancelExamBook(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('取消预约成功！')
          this.cancelMakeAnAppointmentVisible = false
          this.getExamBookList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 获取体检套餐详情
    getExamBookDetail(record) {
      let data = {
        hospitalCode: this.hospitalCode,
        reserveId: record.reserveId,
      }
      this.$API.getExamBookDetail(data).then((res) => {
        this.packagePrice = res.data.packagePrice
        if (this.SCREEN.mobile) {
          this.selectPaymentPhone(record)
        } else {
          this.immediatelyPay(record)
        }
      })
    },
    // 体检预约记录-立即支付
    immediatelyPay(record) {
      if (!this.isShowTjFeeDialog) {
        return
      }
      this.isShowTjFeeDialog = false
      this.showPayModel = true
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.zIndex = 1000
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.position = 'relative'
      let orderCode = record.reserveId
      let hisPatientId = this.activeHisPatientId
      let fee = this.packagePrice * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentRecord.fee = this.packagePrice
      this.paymentFee = this.packagePrice
      this.examBooKMail = record.packageName
      this.examBookTime = record.reserveTime
      let data = {
        sys: 'H02',
        source: 'qr',
        platform: 'wxpay',
        payType: 'web',
        businessId: 'C1',
        businessType: '体检套餐支付',
        productId: orderCode,
        productName: record.packageName,
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        payId: null,
        openId: null,
        unionId: null,
        bizChannel: 7,
        // accessType: 10,
      }
      this.$API.goPaySuzhou(data).then((res) => {
        if (res && res.code == '0') {
          this.paymentQrCode = res.data.payParams.qrContent
          this.paymentVisible = true
          this.getQrCode()
          this.isShowTjFeeDialog = true
        }
      })
    },
    // 关闭支付弹窗
    closePayModel() {
      this.showPayModel = false
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.zIndex = 1
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.position = 'unset'
    },
    // 关闭支付成功弹窗
    closePaySuccessModel() {
      this.showPaySuccessModel = false
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.zIndex = 1
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.position = 'unset'
    },
    // 体检预约记录-重新预约
    refreshMakeAnAppointment() {
      // 跳转页面
      this.$router.push('/medicalCenter/medicalPlan')
    },
    // 报告查询下拉人选择
    reportConsultantPeopleChange(value) {
      this.activeHisPatientId = value
      for (let i = 0; i < this.consultantData.length; i++) {
        if (this.consultantData[i].hisId == value) {
          this.activePerson = this.consultantData[i]
        }
      }
    },
    // 报告类型选择下拉框
    // handleChangeReportType(value) {
    //   this.activeReportType = value;
    // },
    // 搜索报告按钮1
    searchReportOne() {
      this.showReport = 2
      this.searchReportTwo()
    },
    // 搜索报告按钮2
    searchReportTwo() {
      if (this.activeReportType == '03') {
        this.getReportQueryTwo()
      } else {
        this.getReportQueryOne()
      }
    },
    // 报告预览
    reviewReport(path) {
      let data = {
        pdfUrl: path,
      }
      this.$message.warning('请耐心等待几秒钟')
      this.$API.getReportPdf(data).then((res) => {
        let binaryData = []
        binaryData.push(res)
        debugger
        let url = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'application/pdf;charset=UTF-8' })
        )
        debugger
        this.iframeSrc =
          this.ROUTE_BASE +
          '/pdf/web/viewer.html?file=' +
          encodeURIComponent(url)
        this.showIframe = true
        console.log('this.iframeSrc:', this.iframeSrc)
      })
    },
    // 将返回的流数据转换为url
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file)
        console.log('进入了1步骤window.createObjectURL')
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        console.log('进入了2步骤window.webkitURL.createObjectURL')
        try {
          url = window.webkitURL.createObjectURL(file)
        } catch (error) {}
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        console.log('进入了3步骤window.URL.createObjectURL')
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {}
      }
      return url
    },
    // 消费明细下拉选人
    statementConsultantPeopleChange(value) {
      this.activeHisPatientId = value
      for (let i = 0; i < this.consultantData.length; i++) {
        if (this.consultantData[i].hisId == value) {
          this.activePerson = this.consultantData[i]
        }
      }
    },
    // 获取消费明细
    getSevenChild(params) {
      if (params == 1) {
        this.showChildTab = 1
        this.getNissinDetailList()
      } else {
        this.showChildTab = 2
        this.getAlreadyPayCost()
      }
    },
    // 查询消费明细
    searchConsume() {
      if (this.showChildTab == 1) {
        this.getNissinDetailList()
      } else {
        this.getAlreadyPayCost()
      }
    },
    // 已缴费记录分页改变
    pageChange(page, pageSize) {
      console.log('page', page)
      this.pagination.current = page
      this.getAlreadyPayCost()
    },

    // 获取消费明细
    getEightChild(params) {
      if (params == 1) {
        this.showChildTab = 1
        this.getOutpatientInvoiceList()
      } else {
        this.showChildTab = 2
        this.getExamInvoiceList()
      }
    },
    // 会员权益列表
    getVipList() {
      // let data = {
      //   // 入参
      // }
      // this.$API.getVipList(data).then((res) => {
      //   this.vipOrderData = res.data;
      // })
    },

    // 优惠券列表
    getCardList() {
      let data = {
        // 入参
        hospitalCode: this.hospitalCode,
        hisPatientId: this.activeHisPatientId,
      }
      this.$API.getCardList(data).then((res) => {
        this.cardData = res.data
      })
    },
    // 切换tab
    changeTab(num) {
      this.activeTab = num
      this.activeBox = num
      if (num == 1) {
        this.getVipList()
      } else if (num == 2) {
        this.getCardList()
      } else if (num == 3) {
        this.getConsultantList()
      } else if (num == 4) {
        // this.getConsultantList1()
        this.getOutpatientBookList()
        this.radioValue = 1
      } else if (num == 5) {
        // this.getConsultantList2()
        this.getExamBookList()
        this.radioValue = 2
      } else if (num == 6) {
        this.showReport = 1
      } else if (num == 7) {
        this.showChildTab = 1
        this.getNissinDetailList()
      } else {
        this.showChildTab = 1
        this.getOutpatientInvoiceList()
      }
    },
    // 支付弹窗返回
    handlePaymentCancel() {
      this.paymentVisible = false
    },
    // 关闭支付弹窗
    closePaymentModal() {
      this.paymentVisible = false
      clearInterval(this.timer)
      this.num = 120
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.position = 'unset'
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.zIndex = 5
    },
    // 支付成功弹窗
    openPaySuccessModal() {
      this.paySuccessVisible = true
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.position = 'relative'
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.zIndex = 1000
      // 支付成功计时器
      this.paySuccessTimer = setInterval(this.successClock, 1000)
    },
    // 支付成功计时器
    successClock() {
      if (this.paySuccessNum > 0) {
        this.paySuccessNum--
      } else {
        this.closePaySuccessModal()
      }
    },
    // 关闭支付成功弹窗
    closePaySuccessModal() {
      this.paySuccessVisible = false
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.position = 'unset'
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.zIndex = 5
      clearInterval(this.paySuccessTimer)
      this.paySuccessNum = 5
    },

    // 手机端支付方式选择
    selectPaymentPhone(record) {
      this.paymentRecord = record
      if (this.paymentRecord.fee == '0') {
        let data = {
          hospitalCode: this.hospitalCode,
          hisPatientId: this.hisPatientId,
          orderCode: this.paymentRecord.orderCode,
          payType: 'web',
          source: 'h5',
        }
        this.$API.zeroBook(data).then((res) => {
          console.log('zeroPhonePay res:', res)
          if (res && res.code == '0') {
            this.$message.success('支付成功！')
          }
        })
      } else {
        this.selectPayPhoneVisible = true
      }
    },
    // 选择手机支付方式
    onChangePayMethod(e) {
      console.log('onChangePayMethod value:', e)
      console.log('onChangePayMethod paySelectValue:', this.paySelectValue)
      if (e.target.value == 1) {
        this.payMethodValue = 'wxpay'
      } else if (e.target.value == 2) {
        this.payMethodValue = 'alipay'
      }
    },
    // 确认选择手机支付
    payMenthodConfirm() {
      if (this.payMethodValue == null) {
        this.$message.warning('请选择支付方式')
        return
      }
      if (this.radioValue == 1) {
        this.goPaymentPhone(this.paymentRecord)
      }
      if (this.radioValue == 2) {
        this.goExamPaymentPhone(this.paymentRecord) // 调用体检支付接口
      }
      // this.selectPayPhoneVisible = false;
    },

    // 门诊去付款手机端
    goPaymentPhone(record) {
      let orderCode = record.orderCode
      let hisPatientId = this.activeHisPatientId
      let fee = record.fee * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentFee = record.fee
      let data = {
        sys: 'H02',
        source: 'h5',
        platform: this.payMethodValue, // 微信：wxpay; 支付宝：alipay;
        payType: 'web',
        businessId: 'A1',
        businessType: '预约支付',
        productId: orderCode,
        productName: '门诊预约',
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        payId: null,
        openId: null,
        unionId: null,
        bizChannel: 7,
        deptCode: record.hisDeptId,
        // accessType: 10,
      }
      this.$API.goPaySuzhou(data).then((res) => {
        if (res && res.code == '0') {
          // this.paymentQrCode = res.data;
          // let u = navigator.userAgent;
          // let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
          // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          // if(isAndroid) {  //android终端
          //   window.open(this.paymentQrCode,"_blank");
          // }else if(isiOS) {   //ios终端
          //   window.location.href = this.paymentQrCode;
          // }

          this.selectPayPhoneVisible = false
          this.payMethodValue = null
          var divBody = document.createElement('div')
          divBody.innerHTML = res.data.payParams.form
          document.body.appendChild(divBody)
          document.forms[0].submit()

          // this.openPayPhoneModal()
        }
      })
    },
    // 打开手机支付中弹框
    // openPayPhoneModal(){
    // this.payPhoneVisible = true;
    // this.timer = setInterval(this.phoneClock, 1000);
    // },
    // 打开手机支付待确认弹框
    openPayPhoneModal() {
      let timer = setTimeout(() => {
        this.showHasPaySuccess = true
        clearTimeout(timer)
      }, 3000)
    },
    // 已完成支付
    hasPaySuccess() {
      if (this.radioValue == 1) {
        this.checkPaymentStatus() // 检查门诊预约支付状态
      }
      if (this.radioValue == 2) {
        this.checkExamPaymentStatus() // 检查体检预约支付状态
      }
    },
    // 重新支付
    refreshPay() {
      // if(this.radioValue==1){
      //   this.goPaymentPhone(this.paymentRecord); // 调用门诊支付接口
      // }
      // if(this.radioValue==2){
      //   this.goExamPaymentPhone(this.paymentRecord); // 调用体检支付接口
      // }
      this.selectPaymentPhone(this.paymentRecord)
    },
    // 手机计时器
    phoneClock() {
      if (this.num > 0) {
        if (this.radioValue == 1) {
          this.checkPaymentStatus() // 检查门诊预约支付状态
        }
        if (this.radioValue == 2) {
          this.checkExamPaymentStatus() // 检查体检预约支付状态
        }
        this.num--
      } else {
        this.closePayPhoneModal()
      }
    },
    // 关闭手机支付中弹框
    closePayPhoneModal() {
      this.payPhoneVisible = false
      clearInterval(this.timer)
      this.num = 120
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.position = 'unset'
      document.getElementsByClassName(
        'person-center-tab-wrap'
      )[0].style.zIndex = 5
    },

    // 体检手机端去付款
    goExamPaymentPhone(record) {
      let orderCode = record.reserveId
      let hisPatientId = this.activeHisPatientId
      let fee = this.packagePrice * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentRecord.fee = this.packagePrice
      this.paymentFee = this.packagePrice
      this.examBooKMail = record.packageName
      this.examBookTime = record.reserveTime
      let data = {
        sys: 'H02',
        ource: 'h5',
        platform: this.payMethodValue, // 微信：wxpay; 支付宝：alipay;
        payType: 'web',
        businessId: 'C1',
        businessType: '体检套餐支付',
        productId: orderCode,
        productName: record.packageName,
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        payId: null,
        openId: null,
        unionId: null,
        bizChannel: 7,
        // accessType: 10,
      }
      this.$API.goPaySuzhou(data).then((res) => {
        console.log('goPayPhone res:', res)
        if (res && res.code == '0') {
          // this.paymentQrCode = res.data;
          // let u = navigator.userAgent;
          // let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
          // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          // if(isAndroid) {  //android终端
          //   window.open(this.paymentQrCode,"_blank");
          // }else if(isiOS) {   //ios终端
          //   window.location.href = this.paymentQrCode;
          // }

          this.selectPayPhoneVisible = false
          this.payMethodValue = null
          var divBody = document.createElement('div')
          divBody.innerHTML = res.data.payParams.form
          document.body.appendChild(divBody)
          document.forms[0].submit()

          // this.openPayPhoneModal()
        }
      })
    },
    // 体检取消预约退款
    goExamRefund(value) {
      let that = this
      if (value.isRefundsAllowed == '0') {
        this.$confirm({
          title: '提示',
          content: '确认取消预约退款？',
          onOk() {
            that.$API
              .examRefund({
                hospitalCode: that.hospitalCode,
                reserveNetId: value.reserveId,
                // packageCode: value.packageInfoList[0].packageCode,
              })
              .then((res) => {
                if (res && res.code == 0) {
                  that.getExamBookList()
                }
              })
          },
          onCancel() {},
        })
      } else if (value.isRefundsAllowed == '1') {
        this.$confirm({
          title: '提示',
          content: '当前体检已登记或已检查，无法退费',
          okText: '确认',
          cancelText: '取消',
          onOk() {},
          onCancel() {},
        })
      }
    },
    // 输入身份证号自动带出出生日期
    enterIdNo() {
      console.log('enterIdNo:', this.consultantForm.idNo)
      if (
        this.consultantForm.idType == '01' &&
        this.consultantForm.idNo.length == 18
      ) {
        let str1 = this.consultantForm.idNo.substring(6, 10)
        let str2 = this.consultantForm.idNo.substring(10, 12)
        let str3 = this.consultantForm.idNo.substring(12, 14)
        let gender = this.consultantForm.idNo.substring(16, 17)
        this.consultantForm.birthday = str1 + '-' + str2 + '-' + str3
        if (gender % 2 == 1) {
          this.consultantForm.gender = '1'
        } else {
          this.consultantForm.gender = '2'
        }
      }
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (process.client) {
          let pathList = to.fullPath.split('#')
          let params = pathList[1]
          switch (params) {
            case '1':
              this.activeBox = 1
              this.activeTab = 1
              this.getVipList()
              break
            case '2':
              this.activeBox = 2
              this.activeTab = 2
              this.getCardList()
              break
            case '3':
              this.activeBox = 3
              this.activeTab = 3
              console.log('执行了 3')
              this.getConsultantList()
              break
            case '4':
              this.activeBox = 4
              this.activeTab = 4
              this.radioValue = 1
              this.activeHisPatientId = this.consultantData[0].hisId
              this.activePerson = this.consultantData[0]
              let time4 = setTimeout(() => {
                console.log('执行了 4')
                this.getOutpatientBookList()
                clearTimeout(time4)
              }, 2000)
              break
            case '5':
              this.activeBox = 5
              this.activeTab = 5
              this.radioValue = 2
              this.activeHisPatientId = this.consultantData[0].hisId
              this.activePerson = this.consultantData[0]
              let time5 = setTimeout(() => {
                console.log('执行了 5')
                this.getExamBookList()
                clearTimeout(time5)
              }, 2000)
              break
            case '6':
              this.activeBox = 6
              this.activeTab = 6
              this.showReport = 1
              console.log('执行了 6')
              break
            case '7':
              this.activeBox = 7
              this.activeTab = 7
              let time7 = setTimeout(() => {
                console.log('执行了 7')
                this.showChildTab = 1
                this.getNissinDetailList()
                clearTimeout(time7)
              }, 2000)
              break
          }
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="less" scoped>
.person-center-tab-wrap {
  position: relative;
  z-index: 1;
  padding-top: 50px;
  &::after {
    clear: both;
    content: '';
    display: block;
    overflow: hidden;
    visibility: hidden;
  }
  /deep/ .ant-table-thead > tr > th {
    background: #0079d4;
    color: #fff;
  }
  img {
    display: inline-block;
  }
  .btn {
    display: inline-block;
    padding: 2px 5px;
    background-color: #0079d4;
    color: #fff;
    border-radius: 4px;
    &:not(:first-child) {
      margin-left: 5px;
    }
  }
  .btn-default {
    background-color: #dbdada;
    color: #333;
  }
  .btn-blue {
    background-color: #65b3ec;
  }
  .left-box {
    .top-box {
      background-color: #0079d4;
      color: #fff;
      height: 120px;
      line-height: 120px;
      font-size: 30px;
      img {
        position: relative;
        left: 40px;
      }
      span {
        position: relative;
        left: 40px;
      }
    }
    li {
      background-color: #0065b5;
      color: #fff;
      padding-left: 30px;
      padding-right: 20px;
      height: 60px;
      line-height: 60px;
      border-top: 1px solid #005aa2;
      &:hover {
        cursor: pointer;
      }
      &.active {
        background-color: #0079d4;
      }
      img {
        position: relative;
        top: -5px;
      }
      span {
        font-size: 18px;
      }
      .one-span {
        position: relative;
        left: 10px;
      }
      .two-span {
        float: right;
        font-size: 20px;
      }
    }
  }
  .admb-5-px {
    margin-bottom: 5px;
    margin-left:0px!important;
  }
}

// 支付方式选择
.payRadioGroup {
  padding: 20px 40px;
}
/deep/ .payMethodRadio {
  span {
    display: inline-block;
  }
  span:nth-child(1) {
    margin-bottom: 5px;
  }
}

.m-screen-pc {
  .left-box {
    float: left;
    width: 300px;
  }
  .right-box {
    width: 827px;
    float: right;
  }
  .vip-management,
  .card-management {
    h2 {
      margin-bottom: 20px;
      font-size: 24px;
    }
  }
  .consultant-management {
    h2 {
      margin-bottom: 20px;
      font-size: 24px;
    }
    .add-consultant-people {
      margin-bottom: 2px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .one-span {
        display: inline-block;
        width: 200px;
        height: 60px;
        line-height: 60px;
        background-color: #60aae0;
        font-size: 16px;
        text-align: center;
        color: #fff;
        cursor: pointer;
      }
      .two-span {
        font-size: 16px;
      }
      .select {
        width: 300px;
      }
    }
  }
  .outpatient-appointment,
  .medical-appointment,
  .vip-management {
    .outpatient-people {
      margin-bottom: 16px;
      &::after {
        clear: both;
        content: '';
        display: block;
        visibility: hidden;
        overflow: hidden;
      }
    }
    h2,
    .select {
      float: left;
    }
    h2 {
      margin-right: 20px;
      font-size: 24px;
    }
    .select {
      width: 300px;
      position: relative;
      top: 4px;
    }
    .two-span {
      float: right;
      position: relative;
      top: 5px;
      font-size: 16px;
    }
  }
  .report-query {
    .report-title-box {
      .report-title {
        margin-right: 20px;
        font-size: 24px;
      }
      .select {
        width: 300px;
      }
    }
    .report-main-box {
      margin-top: 20px;
      padding: 80px;
      box-shadow: 0 4px 16px #ddd, 0 0 4px #ddd, 0 0 4px #ddd;
      .type-box {
        margin-bottom: 10px;
        .type-span {
          font-size: 16px;
        }
        .select {
          width: 614px;
        }
      }
      .time-box {
        margin-bottom: 30px;
        .time-span {
          font-size: 16px;
        }
        .time-picker {
          width: 280px;
        }
        .to {
          margin: 0 17px;
        }
      }
      .search-box {
        margin-bottom: 60px;
        text-align: center;
        .btn-box {
          display: inline-block;
          text-align: center;
          width: 300px;
          height: 55px;
          line-height: 55px;
          background-color: #0079d4;
          color: #fff;
          border-radius: 40px;
          img {
            margin-right: 10px;
          }
          .search-span {
            font-size: 16px;
          }
        }
      }
      .report-tab {
        .report-tab-head {
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          p {
            position: relative;
            width: 193px;
            height: 55px;
            line-height: 55px;
            background-color: #65b3ec;
            text-align: center;
            border-radius: 4px;
            .text {
              color: #fff;
              font-size: 16px;
            }
            img {
              margin-right: 10px;
            }
            .triangle {
              position: absolute;
              bottom: -10px;
              left: 90px;
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-top: 10px solid #0078d4;
            }
            &.active {
              background-color: #0079d4;
            }
          }
        }
      }
    }
    .search-two-box {
      margin: 10px 0 20px 0;
      .type-span,
      .time-span,
      .to {
        font-size: 16px;
      }
      .time-span {
        margin-left: 10px;
      }
      .to {
        margin: 0 10px;
      }
      .select {
        width: 200px;
      }
      .time-picker {
        width: 150px;
      }
      .search-btn {
        margin-left: 10px;
        display: inline-block;
        width: 97px;
        height: 32px;
        background: #0079d4;
        color: #fff;
        text-align: center;
        line-height: 32px;
        border-radius: 22px;
        font-size: 16px;
      }
    }
  }
  .statement {
    .title-box {
      .consumption-span {
        margin-right: 20px;
        font-size: 24px;
      }
      .select {
        width: 300px;
      }
    }
    .search-box {
      margin-top: 20px;
      margin-bottom: 1px;
      .one-span,
      .two-span {
        display: inline-block;
        width: 112px;
        height: 54px;
        line-height: 54px;
        border: 1px solid #bebebe;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        &.active {
          background: #0079d4;
          border-color: #0079d4;
          color: #fff;
        }
      }
      .three-span {
        margin-left: 20px;
      }
      .to {
        margin: 0 6px;
      }
      .five-span {
        margin-left: 10px;
        display: inline-block;
        width: 97px;
        height: 44px;
        background: #0079d4;
        color: #fff;
        text-align: center;
        line-height: 44px;
        border-radius: 22px;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
  .iframe-box {
    position: fixed;
    top: 15%;
    left: 10%;
    width: 80%;
    height: 80%;
    z-index: 10000;
    .close-span {
      position: absolute;
      right: -37px;
      top: -10px;
      background: #aaa;
      padding: 10px 15px;
      border-radius: 50%;
      color: #fff;
      cursor: pointer;
    }
  }
}

.m-screen-mobile {
  .left-box {
    margin: 0 auto;
    float: none;
    width: 96%;
    .top-box {
      height: 1.5rem;
      line-height: 1.5rem;
      img {
        height: 1rem;
      }
      span {
        font-size: 24px;
      }
    }
    li {
      height: 1rem;
      line-height: 1rem;
    }
  }
  .right-box {
    margin: 0 auto;
    float: none;
    width: 96%;
  }
  .consultant-management {
    h2 {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 24px;
      text-align: center;
    }
    .add-consultant-people {
      margin-bottom: 2px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .one-span {
        display: inline-block;
        width: 3rem;
        height: 1rem;
        line-height: 1rem;
        background-color: #60aae0;
        font-size: 14px;
        text-align: center;
        color: #fff;
      }
      .two-span {
        font-size: 14px;
      }
    }
    .line {
      margin: 10px 0;
      width: 100%;
      height: 0;
      border-bottom: 1px solid #ddd;
    }
  }
  .mobile-table {
    ul {
      margin-bottom: 10px;
    }
    li {
      padding:10px;
      background-color: #f5f5f5;
      border-bottom: 1px solid #e8e8e8;
      &:first-child {
        border-top: 1px solid #e8e8e8;
      }
      &::after {
        clear: both;
        content: '';
        display: block;
        overflow: hidden;
        visibility: hidden;
      }
      .one-span {
        text-align: right;
        float: left;
        width: 30%;
        font-size: 14px;
      }
      .two-span {
        box-sizing: border-box;
        float: left;
        font-size: 14px;
        width: 69%;
        padding-left: 8px;
        word-break: break-all;
      }
    }
  }
  .btn {
    height: 0.6rem;
    line-height: 0.6rem;
    padding: 0 5px;
  }
  .outpatient-mobile-people {
    h2 {
      margin: 20px 0;
      text-align: center;
    }
    .select {
      width: 100%;
      /deep/ .ant-select-selection-selected-value {
        width: 100%;
        text-align: center;
      }
    }
    .two-span {
      margin: 20px 0;
      display: block;
      text-align: center;
    }
  }
  .report-query {
    .report-title-box {
      text-align: center;
      .report-title {
        margin: 0.5rem 0;
        text-align: center;
        font-size: 0.5rem;
        width: 100%;
        display: block;
      }
      .select {
        width: 100%;
        /deep/ .ant-select-selection-selected-value {
          width: 100%;
          text-align: center;
        }
      }
    }
    .report-main-box {
      margin-top: 20px;
      padding: 0.25rem;
      box-shadow: 0 4px 16px #ddd, 0 0 4px #ddd, 0 0 4px #ddd;
      .type-box {
        margin-bottom: 10px;
        .type-span {
          font-size: 0.4rem;
        }
        .select {
          width: 5.3rem;
        }
      }
      .time-box {
        margin-bottom: 30px;
        .time-span {
          font-size: 0.4rem;
        }
        .time-picker {
          width: 2.4rem;
        }
      }
      .search-box {
        margin-bottom: 0.5rem;
        text-align: center;
        .btn-box {
          display: inline-block;
          text-align: center;
          width: 100%;
          height: 0.8rem;
          line-height: 0.8rem;
          background-color: #0079d4;
          color: #fff;
          border-radius: 0.6rem;
          img {
            width: 0.5rem;
            height: 0.5rem;
            margin-right: 0.15rem;
          }
          .search-span {
            font-size: 0.4rem;
          }
        }
      }
      .report-tab {
        .report-tab-head {
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          p {
            position: relative;
            width: 2.4rem;
            height: 1rem;
            line-height: 1rem;
            background-color: #65b3ec;
            text-align: center;
            border-radius: 4px;
            .text {
              color: #fff;
              font-size: 0.3rem;
            }
            img {
              position: relative;
              top: -0.1rem;
              width: 0.4rem;
              height: 0.4rem;
              margin-right: 0.1rem;
            }
            .triangle {
              position: absolute;
              bottom: -0.25rem;
              left: 1rem;
              width: 0;
              height: 0;
              border-left: 0.25rem solid transparent;
              border-right: 0.25rem solid transparent;
              border-top: 0.25rem solid #0078d4;
            }
            &.active {
              background-color: #0079d4;
            }
          }
        }
      }
    }
    .report-two-title-box {
      margin-bottom: 0.5rem;
      .report-title {
        margin: 0.25rem 0;
        text-align: center;
        font-size: 0.4rem;
      }
      .select {
        width: 100%;
        /deep/ .ant-select-selection-selected-value {
          width: 100%;
          text-align: center;
        }
      }
    }
    .search-three-box {
      margin-bottom: 0.25rem;
      .select {
        width: 6.1rem;
      }
    }
    .search-four-box {
      margin-bottom: 0.5rem;
      .time-picker {
        width: 2.8rem;
      }
    }
    .search-btn-box {
      margin-bottom: 0.8rem;
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      background: #0079d4;
      color: #fff;
      border-radius: 1rem;
    }
    .line {
      margin-bottom: 0.25rem;
      width: 100%;
      height: 0;
      border-bottom: 2px solid #ddd;
    }
  }
  .statement {
    .title-box {
      margin-bottom: 0.4rem;
      .consumption-h2 {
        margin: 0.5rem 0;
        text-align: center;
      }
      .select {
        width: 100%;
        /deep/ .ant-select-selection-selected-value {
          width: 100%;
          text-align: center;
        }
      }
    }
    .search-box-one {
      margin-bottom: 0.25rem;
      display: flex;
      justify-content: space-between;
      span {
        display: inline-block;
        height: 1rem;
        line-height: 1rem;
        width: 49%;
        font-size: 0.3rem;
        border: 1px solid #bebebe;
        border-radius: 4px;
        text-align: center;
        &.active {
          background: #0079d4;
          border-color: #0079d4;
          color: #fff;
        }
      }
    }
    .search-box-two {
      margin-bottom: 0.25rem;
      .time-picker {
        width: 2.8rem;
      }
      .search-div {
        margin-top: 0.25rem;
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background: #0079d4;
        color: #fff;
        border-radius: 0.5rem;
      }
    }
  }
  .iframe-box {
    position: fixed;
    top: 2%;
    left: 10%;
    width: 80%;
    height: 90%;
    z-index: 10000;
    .close-span {
      position: absolute;
      right: -37px;
      top: -10px;
      background: #aaa;
      padding: 10px 15px;
      border-radius: 50%;
      color: #fff;
      cursor: pointer;
    }
  }

  .pay-success-model-box {
    width: 300px;
    height: 210px;
    margin-left: -150px;
  }
}

.add-consultant-people-dialog {
  padding: 20px;
  .width-220-px {
    width: 220px;
  }
  ul {
    &::after {
      clear: both;
      content: '';
      display: block;
      overflow: hidden;
      visibility: hidden;
    }
  }
  li {
    float: left;
    margin-bottom: 10px;
    width: 50%;
    .one-span {
      float: left;
      width: 30%;
      height: 32px;
      line-height: 32px;
    }
    .two-span {
      float: left;
      width: 70%;
      position: relative;
    }
    .send-yzm {
      position: absolute;
      top: 0;
      right: 36px;
      width: 80px;
      height: 32px;
      line-height: 32px;
      background-color: #0078d4;
      color: #fff;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
.add-consultant-people-mobile-dialog {
  li {
    .one-span,
    .two-span {
      display: block;
      width: 100%;
      margin-bottom: 0.25rem;
    }
    .select {
      width: 100%;
    }
    .two-span {
      position: relative;
      .send-yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 2rem;
        height: 32px;
        line-height: 32px;
        background-color: #0078d4;
        color: #fff;
        text-align: center;
        border-radius: 4px;
      }
    }
  }
}

.paymentModal {
  /deep/ .ant-modal-wrap {
    .ant-modal {
      .ant-modal-content {
        .ant-modal-body {
          .qrcodeBox {
            width: 145px;
            height: 145px;
            margin: 0 auto;
            margin-top: 15px;
          }
        }
        .ant-modal-footer {
          text-align: right;
        }
      }
    }
  }
}

.qrcodeBox1 {
  width: 145px;
  height: 145px;
  margin: 0 auto;
  margin-top: 15px;
}

.wemsk {
  background: url(../images/mask50.png);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9998;
  left: 0;
  top: 0;
  display: block;
}
.ewmboxfix {
  // -webkit-box-shadow: 0px 1px 20px 0px #f5f5f5;
  // box-shadow: 0px 1px 20px 0px #f5f5f5;
  width: 50%;
  // height: 50%;
  overflow: hidden;
  border-radius: 5px;
  position: fixed;
  z-index: 999;
  left: 50%;
  top: 30%;
  margin-left: -25%;
  // margin-top: -25%;
  background: #fff;
  border: 5px solid #fff;
  display: block;
  padding: 20px;
  .closeBtn {
    text-align: right;
    margin-bottom: 20px;
  }
  .payInfo {
    margin-bottom: 20px;
    .left {
      .main {
        font-size: 0.18rem;
        color: #222222;
        font-weight: 400;
      }
      .txt {
        margin-top: 0.18rem;
        font-size: 0.16rem;
        color: #999999;
        font-weight: 400;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .payable {
        font-size: 0.2rem;
        color: #333333;
        font-weight: 400;
      }
      .money {
        font-size: 0.26rem;
        color: #f29e0c;
        font-weight: 400;
      }
    }
  }
  .qrcodeBox {
    width: 145px;
    margin: 0 auto 20px;
  }
  .tipInfo {
    font-size: 0.18rem;
  }
}
.pay-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -288px;
  margin-left: -331px;
  width: 662px;
  height: 576px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .pay-main-box {
    .title {
      width: 100%;
      height: 120px;
      background-color: #f8f9ff;
      .top-title {
        padding-top: 20px;
        text-align: center;
        font-size: 18px;
        position: relative;
        font-weight: bold;
        .close-span {
          position: absolute;
          right: 20px;
          top: 0px;
          color: #999;
          font-size: 30px;
          font-weight: normal;
          cursor: pointer;
        }
      }
      .two-box {
        margin: 10px 0;
        text-align: center;
        font-size: 12px;
        span {
          font-weight: bold;
        }
      }
      .three-box {
        text-align: center;
        span {
          font-weight: bold;
        }
      }
    }
    .pay-money {
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      span {
        color: #ff4d4f;
        font-size: 24px;
      }
    }
    .img-box {
      margin-top: 20px;
      box-sizing: border-box;
      padding: 0 80px;
      display: flex;
      justify-content: space-between;
      .left-img-box {
        border: 1px solid #ddd;
        .qrcode-box {
          width: 224px;
          height: 224px;
          padding: 20px;
          #qrcode {
            width: 100%;
            height: 100%;
          }
        }
        .bottom-remind-box {
          box-sizing: border-box;
          margin-top: 12px;
          padding-top: 8px;
          padding-left: 20px;
          border-top: 1px solid #ddd;
          &::after {
            clear: both;
            display: block;
            content: '';
            overflow: hidden;
          }
          .img {
            float: left;
          }
          .txt {
            margin-left: 20px;
            float: left;
            font-size: 12px;
          }
        }
      }
      .right-img-box {
        img {
          width: 210px;
          height: 288px;
        }
      }
    }
    .red-txt-box {
      margin-top: 20px;
      padding: 0 80px;
      .content-red-box {
        background-color: #fff1f0;
        border: 1px solid #ffa39e;
        padding-left: 24px;
        height: 40px;
        line-height: 40px;
        img {
          margin-right: 8px;
        }
      }
    }
  }
}
.pay-success-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -130px;
  margin-left: -331px;
  width: 662px;
  height: 260px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .top-title {
    margin-top: 20px;
    text-align: center;
    font-size: 18px;
    position: relative;
    font-weight: bold;
    .close-span {
      position: absolute;
      right: 20px;
      top: -16px;
      color: #999;
      font-size: 30px;
      font-weight: normal;
      cursor: pointer;
    }
  }
  .middle-box {
    margin: 60px 0;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    img {
      margin-right: 10px;
      width: 50px;
      height: 50px;
    }
    span {
      color: #ff7f81;
    }
  }
  .bottom-box {
    text-align: center;
    font-size: 12px;
    color: #404555;
  }
}
.has-pay-success {
  position: fixed;
  width: 4rem;
  height: 2.5rem;
  z-index: 9999;
  top: 30%;
  left: 20%;
  background-color: #fff;
  border-radius: 6px;
  .gth-box {
    margin-top: 0.2rem;
    text-align: center;
    .gth {
      display: inline-block;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      border: 1px solid red;
      color: red;
    }
  }
  .txt {
    margin: 10px 0;
    text-align: center;
  }
  .btn-box {
    display: flex;
    justify-content: space-between;
    padding: 0 0.2rem;
    p {
      border: 1px solid #ddd;
      padding: 0.1rem 0.2rem;
      border-radius: 0.5rem;
    }
    .red-btn {
      background-color: red;
      border-color: red;
      color: #fff;
    }
  }
}
</style>
